<template>
  <div class="form">
    <b-modal class="custom-modal" v-model="showModal" title="Wróć do strony głównej" @ok="goBack">
      <p>Powrót na stronę główną spowoduje utratę wszystkich udzielonych odpowiedzi. Formularz będzie należało wypełnić ponownie.</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button class="btn-modal" @click="cancel">Kontynuuj wypełnianie formularza</b-button>
        <b-button class="btn-modal red" @click="ok">Wróć do strony głównej</b-button>
      </template>
    </b-modal>
    <svg class="shape-1" xmlns="http://www.w3.org/2000/svg" width="241" height="172" viewBox="0 0 241 172" fill="none">
      <path d="M137.398 27.4683C146.079 29.7416 154.752 30.0607 163.325 30.8532C181.781 32.5572 200.238 34.6108 218.83 34.257C222.593 34.182 226.195 34.8481 229.577 36.626C237.487 40.7742 241.894 49.4812 240.576 58.4554C239.278 67.2032 232.287 74.3871 223.435 75.7351C220.389 76.1985 217.28 76.1477 214.192 76.2204C196.214 76.6543 178.391 74.5778 160.509 73.2216C159.302 73.123 158.055 73.1069 156.869 73.2756C156.603 73.3177 156.116 74.5126 156.281 74.6972C157.739 76.2761 159.258 77.8137 160.879 79.2686C170.564 87.9569 180.29 96.6041 189.975 105.292C191.821 106.952 193.648 108.653 195.229 110.54C201.351 117.925 201.897 127.818 196.75 135.674C191.888 143.098 182.818 146.545 173.995 144.334C169.696 143.258 166.047 141.008 162.764 138.058C146.636 123.549 130.548 109 114.359 94.5538C109.27 90.0253 103.896 85.827 98.6036 81.5461C97.7011 80.8087 96.5316 79.7842 95.3492 80.8993C94.7988 81.4156 94.5571 82.5067 94.5396 83.3297C94.4068 92.0323 94.2535 100.735 94.3048 109.457C94.3819 125.462 91.2663 140.964 86.9841 156.265C86.2367 158.921 85.2032 161.62 83.7386 163.929C76.9038 174.61 61.7671 174.416 55.0201 163.681C53.0043 160.479 51.7851 156.965 51.6693 153.139C51.5096 148.47 51.309 143.821 51.4152 139.151C51.7338 125.161 52.2162 111.17 52.6167 97.1792C52.6704 95.0189 52.6422 92.8383 52.5322 90.6581C52.4663 89.3828 50.868 88.5244 49.7862 89.1866C47.6841 90.4901 45.623 91.8757 43.5825 93.2613C30.8297 102.05 17.9947 110.715 4.64539 118.559C0.910038 120.753 -2.86634 122.906 -6.80783 124.648C-15.038 128.298 -23.6489 128.369 -32.2672 126.363C-34.9079 125.755 -37.5715 124.489 -39.7861 122.913C-49.3419 116.096 -48.7764 102.475 -38.8166 96.3095C-36.1633 94.6749 -33.242 93.6565 -30.176 93.0491C-26.783 92.3787 -23.72 90.9278 -20.9455 88.8608C-6.58387 78.0918 7.77767 67.3022 22.1186 56.4716C22.5266 56.1616 22.5854 55.4002 22.8084 54.844C21.677 53.0376 19.6322 53.2094 17.9538 52.8862C-2.41144 49.1112 -22.7764 45.4391 -43.1616 41.8082C-45.8837 41.3241 -48.7266 41.3959 -51.4487 40.9118C-54.7848 40.3476 -58.2229 39.8248 -61.3565 38.6633C-68.996 35.8102 -73.7461 28.6884 -73.8357 20.7067C-73.9269 12.293 -68.9819 5.11628 -60.9131 2.10475C-57.1136 0.692393 -53.1474 0.164044 -49.0983 -0.0765704C-39.1188 -0.667332 -29.3768 0.964564 -19.6547 2.78168C-11.7951 4.25564 -3.91518 5.66783 3.92384 7.10073C4.58915 4.36225 2.76513 3.36066 1.55391 2.11004C-9.90123 -9.6785 -21.3563 -21.4671 -32.8726 -33.1937C-38.1074 -38.5445 -42.6281 -44.4328 -46.4758 -50.8583C-48.7597 -54.6767 -49.9197 -58.8076 -49.772 -63.2929C-49.3681 -76.3166 -36.4258 -83.6038 -25.2139 -76.9575C-22.3033 -75.2397 -19.6976 -72.9654 -17.1737 -70.6908C-1.25081 -56.4288 14.6722 -42.1257 30.4933 -27.7399C38.3114 -20.6495 46.3942 -13.9099 54.7622 -7.50033C55.5005 -6.94749 56.2592 -6.41528 57.0586 -5.92438C58.8011 -4.84021 60.2104 -5.42122 60.2855 -7.31413C60.379 -9.80372 60.3497 -12.2929 60.3613 -14.7822C60.2964 -33.1324 60.3337 -51.4831 60.1256 -69.8328C60.0624 -76.1277 60.8384 -82.261 62.2284 -88.3142C64.001 -96.0351 68.3779 -101.914 75.9975 -104.677C90.0519 -109.787 105.246 -99.1023 103.663 -84.1817C101.168 -60.8645 103.009 -37.5832 102.396 -14.2931C102.361 -12.7295 102.326 -11.1865 102.413 -9.62327C102.563 -7.52543 101.571 -4.76524 103.518 -3.55837C105.773 -2.14685 107.359 -4.78571 108.93 -6.02561C124.024 -17.9081 139.015 -29.9137 153.411 -42.6783C156.898 -45.7559 160.364 -48.854 163.933 -51.829C165.83 -53.3992 167.829 -54.9698 169.993 -56.0884C178.629 -60.542 188.37 -59.1981 194.938 -52.8027C201.342 -46.5714 203.403 -36.2308 199.976 -27.8046C197.665 -22.1391 194.02 -17.3123 188.691 -14.6396C181.912 -11.2623 176.469 -6.24399 170.697 -1.61537C160.295 6.71208 149.995 15.1832 139.675 23.6132C138.758 24.3776 137.594 25.0195 137.398 27.4271L137.398 27.4683Z" fill="#007CC2"/>
    </svg>
    <svg class="shape-2" :class="[{step1: currentStep === 1}, {step2: currentStep === 2}]" width="147" height="197" viewBox="0 0 147 197" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M69.6808 8.43687C69.2228 8.60014 68.8725 8.77701 68.5221 8.95388C63.551 11.0899 59.0536 17.2657 59.0536 17.2657L39.2163 43.6148L17.7897 72.101C13.5577 77.7274 12.5956 85.1646 15.2567 91.6827L46.3714 167.896L96.4283 102.248C99.9799 97.5003 107.177 93.3238 113.419 94.1121C113.526 94.1257 115.356 94.3567 118.584 94.7645L115.356 94.3567C108.899 93.5412 101.405 87.9515 98.8906 81.8852L71.9862 17.0196C71.826 16.5571 71.652 16.2035 71.5718 15.9723C71.4116 15.5098 71.3589 15.0609 71.1987 14.5985C71.146 14.1496 71.0934 13.7008 71.0407 13.2519L71.0545 13.1431C71.0957 12.8166 71.043 12.3677 71.1919 12.0549C71.2331 11.7284 71.2881 11.2932 71.4369 10.9803C71.4507 10.8715 71.572 10.7762 71.5858 10.6674C71.7209 10.4634 71.7484 10.2458 71.8835 10.0417C72.0048 9.9465 72.1399 9.74243 72.1537 9.6336C72.2888 9.42956 72.4239 9.22555 72.6666 9.0351C72.788 8.93987 72.9093 8.8446 73.0444 8.64056C73.1658 8.54534 73.2872 8.45013 73.4085 8.35491C73.7589 8.17803 74.1092 8.00118 74.4595 7.82432C74.6885 7.74269 74.9175 7.66107 75.2541 7.59301C75.4831 7.51138 75.5907 7.52494 75.8197 7.44331L75.9273 7.4569C76.3715 7.40245 76.9233 7.36161 77.4752 7.32075C74.5283 7.28022 71.863 7.60692 69.6808 8.43687Z" fill="#F6B09D"/>
      <path d="M77.0205 7.59378C77.3441 7.63464 77.6814 7.56698 78.1129 7.62147C77.5598 7.66188 77.0068 7.70228 76.5617 7.75632L76.4538 7.7427C76.2244 7.82398 76.1165 7.81037 75.8871 7.89165C75.6577 7.97294 75.3204 8.04058 75.0909 8.12186C74.7399 8.29805 74.3889 8.47424 74.0379 8.65043C73.9164 8.74533 73.7948 8.84022 73.6732 8.93513C73.5517 9.03003 73.4301 9.12496 73.2948 9.32839C73.1595 9.53182 72.9164 9.7216 72.7811 9.92503C72.6596 10.0199 72.5243 10.2234 72.5106 10.3319C72.3753 10.5353 72.24 10.7388 72.2126 10.9558C72.1989 11.0643 72.0774 11.1593 72.0636 11.2678C71.9147 11.5797 71.8735 11.9053 71.8187 12.3394C71.7776 12.665 71.7365 12.9906 71.6817 13.4247L71.6679 13.5332C71.721 13.9809 71.6662 14.415 71.8271 14.8764C71.8801 15.3241 72.041 15.7855 72.2019 16.2468C72.2823 16.4775 72.3491 16.8167 72.6179 17.2917L99.6209 82.005C102.144 88.057 109.55 93.6232 116.13 94.4541L119.366 94.8628L278.138 114.915C284.61 115.732 287.869 111.623 285.359 105.463L258.37 40.6407C255.847 34.5886 248.454 28.914 241.875 28.083L79.7582 7.60873C78.7737 7.59466 77.8971 7.59423 77.0205 7.59378Z" fill="#983628"/>
      <path d="M277.928 115.01C277.928 115.01 114.068 94.4259 113.433 94.2357C107.164 93.444 99.9421 97.5962 96.3808 102.321L46.1856 167.652L92.3349 173.481L112.638 176.077L198.791 187.092L233.025 191.469C233.025 191.469 283.438 125.284 283.736 124.661C283.736 124.661 288.098 117.946 285.966 107.879C286.768 112.824 283.548 115.72 277.928 115.01Z" fill="#FF4337"/>
    </svg>
    <svg class="shape-3" :class="[{step1: currentStep === 1}, {step2: currentStep === 2}]" width="352" height="324" viewBox="0 0 352 324" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M113.723 269.46C114.716 269.971 187.973 278.91 187.973 278.91C191.62 279.128 195.278 278.501 198.657 277.08C202.036 275.659 205.042 273.483 207.437 270.725L309.053 138.873C310.923 136.253 312.201 133.27 312.8 130.13C313.399 126.991 313.305 123.768 312.523 120.684C313.328 125.375 310.221 128.431 304.403 127.817L234.035 119.138C230.422 118.511 227.019 117.054 224.097 114.883C221.176 112.712 218.819 109.889 217.214 106.639L215.515 102.598L217.234 106.686C218.468 110.047 218.888 113.656 218.458 117.226C218.029 120.795 216.762 124.226 214.76 127.245L193.233 155.379L113.503 258.891L113.267 258.99C109.984 263.214 105.877 263.629 102.842 260.641C105.359 264.708 109.189 267.811 113.723 269.46Z" fill="#A18037"/>
      <path d="M76.6157 241.626L101.134 258.096C103.694 264.181 109.142 264.842 113.258 259.558L214.807 127.68C216.809 124.661 218.075 121.23 218.505 117.661C218.934 114.091 218.515 110.482 217.281 107.121L185.806 32.2793L156.477 70.4191L95.4719 148.358L43.7459 214.441L76.6157 241.626Z" fill="#FFE4B9"/>
      <path d="M203.289 34.0575L185.853 32.2596L217.328 107.101C218.932 110.351 221.29 113.174 224.211 115.345C227.132 117.516 230.536 118.973 234.149 119.6L304.516 128.278C311.144 129.1 314.502 124.79 311.923 118.657L284.534 53.5294C281.65 46.6721 275.216 41.9371 267.818 41.1529C250.987 39.3687 221.57 36.1392 202.911 34.2164" fill="#FCC157"/>
    </svg>
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" xl="10">
          <div class="box-return ml-2 ml-md-0">
            <div class="box-return box-return--point mb-0" @click="checkIfFormFilled">
              <img src="../../assets/media/icons/chevron-left-plain.svg" alt="Icon left" />
              <p>wróć</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  <section>
    <b-container v-if="!formSelected || formSelected === ''">
      <b-row>
        <b-col class="text-center" cols="12">
          <h1>Formularz rejestracyjny do programu Solve for Tomorrow</h1>
          <p class="mt-5">Zanim przejdziesz do formularza, zaznacz jaką pełnisz rolę:</p>
        </b-col>
      </b-row>
      <b-row class="form-type-buttons">
        <b-col md="12" lg="6" class="text-center mb-3">
          <b-button @click="formSelected = 'school'" variant="secondary">Nauczyciel/-ka szkoły podstawowej (klasy 7-8)</b-button>
        </b-col>
        <b-col md="12" lg="6" class="text-center mb-3">
          <b-button @click="formSelected = 'university'" variant="info">Nauczyciel/-ka szkoły ponadpodstawowej</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <a class="link-statute" href="https://solvefortomorrow.pl/wp-content/uploads/2024/09/regulamin_Solve_for_Tomorrow_PL_4.pdf" target="_blank">Regulamin programu</a>
        </b-col>
      </b-row>
    </b-container>
    <form v-else @submit="this.nextStep">
      <b-container v-if="formSelected === 'school'">
        <b-row>
          <b-col class="form-head text-center" :class="currentStep >= 2 ? 'mb-7' : ''">
            <h3 class="form-title">Formularz zgłoszeniowy do programu Solve for Tomorrow</h3>
<!--            <p>Aby wziąć udział w programie Solve for Tomorrow, wypełnij poniższy formularz.</p>-->
<!--            <p>Formularz wypełnia opiekun/opiekunka (nauczyciel/nauczycielka za zgodą dyrektora/dyrektorki placówki).</p>-->
<!--            <p>Przed przystąpieniem do uzupełniania formularza zapoznaj się z regulaminem.</p>-->
            <a v-if="!this.formSend && this.currentStep === 0" class="form-head__link ml-0 mt-3" href="https://solvefortomorrow.pl/wp-content/uploads/2024/09/regulamin_Solve_for_Tomorrow_PL_4.pdf" target="_blank">Regulamin</a>
            <div class="form-head__box" v-if="currentStep < 2">
              <p>Formularz wypełnia opiekun/opiekunka <br /> (nauczyciel/nauczycielka za zgodą dyrektora placówki)</p>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="12" lg="10">
            <b-row align-h="center">
              <b-col cols="12" xl="5" class="hr_container">
                <div class="number" v-if="currentStep === 0" :class="[{active: currentStep === 0},{finished: currentStep > 0}]">01</div>
                <div class="" v-if="currentStep > 0" :class="[{active: currentStep === 0},{finished: currentStep > 0}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="number-line"></div>
                <div class="number" v-if="currentStep < 2" :class="[{active: currentStep === 1},{finished: currentStep > 1}]">02</div>
                <div class="" v-if="currentStep >= 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="number-line"></div>
                <div class="number" v-if="currentStep < 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">03</div>
                <div class="" v-if="currentStep >= 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-3 text-center">
              <b-col class="number-text" :class="[{active: currentStep === 0},{finished: currentStep > 0}]" cols="3" xl="2">
                <p>Aplikacja</p>
              </b-col>
              <b-col class="number-text" :class="[{active: currentStep === 1},{finished: currentStep > 1}]" cols="3" xl="2">
                <p>Regulamin, zgody i oświadczenia</p>
              </b-col>
              <b-col class="number-text" :class="[{active: currentStep === 2},{finished: currentStep > 2}]" cols="3" xl="2">
                <p>Potwierdzenie</p>
              </b-col>
            </b-row>
            <b-row v-if="currentStep === 0">
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title yellow">Informacje o Tobie</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Imię i nazwisko opiekuna/opiekunki zespołu *" v-model="schoolForm.first_name"></b-input>-->
<!--                      <p>Imię i nazwisko <span class="color">*</span></p>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <b-input class="mb-4" required placeholder="Nazwisko" v-model="schoolForm.last_name"></b-input>&ndash;&gt;-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" placeholder="Adres e-mail opiekuna/opiekunki zespołu *" required type="email" v-model="schoolForm.email"></b-input>-->
<!--                      <p>Adres e-mail <span class="color">*</span></p>-->
<!--                    </div>-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Numer telefonu opiekuna/opiekunki zespołu *" v-model="schoolForm.phone"></b-input>-->
<!--                      <p>Numer telefonu <span class="color">*</span></p>-->
<!--                    </div>-->
<!--                    <h5 class="mt-5 mb-4">Jakiego przedmiotu/przedmiotów uczysz?</h5>-->
<!--                    <div class="input-box">-->
<!--                      <b-textarea class="input" rows="4" required placeholder="Wypisz przedmiot/-y" v-model="schoolForm.subjects"></b-textarea>-->
<!--                      <p>Wypisz przedmiot/-y</p>-->
<!--                    </div>-->
<!--                    <h5 class="mt-5 mb-4">Twoja główna funkcja w szkole</h5>-->
<!--                    <b-select class="mb-4" required :options="teacherRoles" v-model="schoolForm.role">-->
<!--                      <template #first>-->
<!--                        <b-select-option value="" disabled>Wybierz</b-select-option>-->
<!--                      </template>-->
<!--                    </b-select>-->
<!--                    <label class="input-control">-->
<!--                      <input type="checkbox" class="label" required v-model="schoolForm.director_consent" />-->
<!--                      Posiadam zgodę dyrektora placówki na udział zgłaszanego zespołu w programie Solve for Tomorrow-->
<!--                    </label>-->
<!--                      <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2022/09/Zgoda_dyrektora_SFT_2_edycja.pdf" target="_blank">(wzór zgody do pobrania).</a>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
              <b-col cols="12" class="form-content">
                <b-row align-h="center">
                  <b-col cols="10" xl="6">
                    <h4 class="form-section-title blue">Informacje o zespole</h4>
                    <div class="input-box">
                      <p>Pełna nazwa placówki, z której pochodzi zespół:</p>
                      <b-input required class="mb-4 input" placeholder="" v-model="schoolForm.school_name"></b-input>
                    </div>
                    <div class="input-box select-box">
                      <p>Adres placówki, z której pochodzi zespół</p>
                      <b-select class="input select" required :options="voivodeships" v-model="schoolForm.school_voivodeship" @blur.native="onBlur" @change.native="onSelectChange" @click.native="toggleDropdown">
                        <template #first>
                          <b-select-option :value="null" class="select" disabled>Województwo</b-select-option>
                        </template>
                      </b-select>
                      <span class="select-icon" :class="{ 'rotate': isSelectFocused }"></span>
                    </div>
                    <div class="input-box">
                      <b-input class="input" required placeholder="Ulica" v-model="schoolForm.school_street"></b-input>
                    </div>
                    <b-row>
                      <b-col cols="12" lg="4">
                        <div class="input-box">
                          <b-input class="w-100 input" maxlength="6" required placeholder="Kod pocztowy" v-model="schoolForm.school_zip"  @input="formatZipCode"></b-input>
                          <span class="input-box-instruction">w formacie 11-222</span>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="input-box">
                          <b-input class="w-100 input" required placeholder="Miejscowość" v-model="schoolForm.school_city"></b-input>
                        </div>
                      </b-col>
                    </b-row>
                    <div class="input-box">
                      <p>Liczba osób w zespole (wraz z opiekunem/opiekunką)</p>
                      <div class="d-flex justify-content-start">
                        <div class="radio-box d-flex flex-wrap justify-content-around">
                          <label class="input-control">
                            <input type="radio" name="teamSize" value="3" v-model="teamSize" required />
                            3 osoby
                          </label>
                          <label class="input-control">
                            <input type="radio" name="teamSize" value="4" v-model="teamSize" required />
                            4 osoby
                          </label>
                          <label class="input-control">
                            <input type="radio" name="teamSize" value="5" v-model="teamSize" required />
                            5 osoby
                          </label>
                        </div>
                        <!--                      <div class="team-size-btn" @click="teamSize=3" :class="{active: teamSize === 3}">-->
                        <!--                        <img src="../../assets/media/icons/three-people.svg"/>-->
                        <!--                        <p class="mb-0 mt-2">3 osoby</p>-->
                        <!--                      </div>-->
<!--                        <div class="team-size-btn" @click="teamSize=4" :class="{active: teamSize === 4}">-->
<!--                          <img src="../../assets/media/icons/four-people.svg"/>-->
<!--                          <p class="mb-0 mt-2">4 osoby</p>-->
<!--                        </div>-->
<!--                        <div class="team-size-btn" @click="teamSize=5" :class="{active: teamSize === 5}">-->
<!--                          <img src="../../assets/media/icons/five-people.svg"/>-->
<!--                          <p class="mb-0 mt-2">5 osób</p>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div class="input-box">
                      <p class="mb-3">Dane opiekuna/opiekunki zespołu</p>
                      <b-input class="input" required placeholder="Imię i nazwisko" v-model="schoolForm.first_name"></b-input>
                      <b-row>
                        <b-col>
                          <b-input class="mt-3 input" required placeholder="Adres email" v-model="schoolForm.email"></b-input>
                        </b-col>
                        <b-col>
                          <b-input class="mt-3 input" maxlength="11" required placeholder="Numer telefonu" v-model="schoolForm.phone" @input="formatPhone"></b-input>
                          <span class="input-box-instruction">w formacie 111 222 333</span>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="input-box">
                      <p class="mb-3">Dane lidera/liderki zespołu</p>
                      <b-input class="input" required placeholder="Imię i nazwisko" v-model="schoolForm.first_name_leader"></b-input>
                      <b-row>
                        <b-col>
                          <b-input class="mt-3 input" required placeholder="Adres email" v-model="schoolForm.email_leader"></b-input>
                        </b-col>
                        <b-col>
                          <b-input class="mt-3 input" maxlength="11" required placeholder="Numer telefonu" v-model="schoolForm.phone_leader" @input="formatPhoneLeader">></b-input>
                          <span class="input-box-instruction">w formacie 111 222 333</span>
                        </b-col>
                      </b-row>
                    </div>
                    <h5 class="star-box">Imiona i nazwiska wszystkich członków, członkiń zespołu (tylko uczniowie i uczennice)</h5>
                    <b-row class="d-flex" v-for="index in teamSize - 1" :key="index">
                      <b-col cols="8">
                        <b-input class="input mt-3" required placeholder="Imię i nazwisko" v-model="schoolForm.team_members[index - 1].firstname"></b-input>
                      </b-col>
                      <b-col cols="4">
                        <p class="star">*</p>
                        <b-input class="input mt-3 input-number-star" required type="number" min="1" max="100" placeholder="Wiek" v-model="schoolForm.team_members[index - 1].age"></b-input>
                      </b-col>
                    </b-row>
                    <b-row class="margin-16">
                      <b-col>
                        <p class="regular-text"><span class="star-red">*</span> Wiek w chwili wypełniania formularza</p>
                      </b-col>
                    </b-row>
                    <div class="input-box">
                      <p class="mb-3">Jeśli jesteś opiekunem/opiekunką zespołu w szkole, jakiego przedmiotu/jakich przedmiotów uczysz?</p>
                      <b-textarea class="input" rows="4" required placeholder="Przedmiot/Przedmioty" v-model="schoolForm.subjects"></b-textarea>
                    </div>
                    <div class="input-box select-box">
                      <p>Funkcja w szkole lub innej placówce opiekuna/opiekunki zespołu</p>
                      <b-select class="input select" required :options="teacherRoles" v-model="schoolForm.role" @blur.native="onBlur" @change.native="onSelectChange" @click.native="toggleDropdown"></b-select>
                      <span class="select-icon" :class="{ 'rotate': isSelectFocused }"></span>
                    </div>
                    <div v-if="schoolForm.role === 'Inne'">
                      <b-input class="input" placeholder="Wpisz swoją funkcję w szkole" required type="text" v-model="schoolForm.custom_role"></b-input>
                    </div>
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.parental_consent" />
                      <p class="regular-consent">Oświadczenie osoby wypełniającej formularz: Posiadam zgodę rodzica lub prawnego opiekuna, opiekunki dla wszystkich niepełnoletnich członków i członkiń zespołu (zgodnie z przekazanym wzorem) i w każdej chwil jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow. Wzór zgody znajduje się w regulaminie. <span class="star-red">*</span></p>
                    </label>
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/zgoda_na_udzial_dziecka_w-programie_SFT_3_edycja.pdf" target="_blank">wzór zgody do pobrania.</a>-->
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.director_consent" />
                      <p class="regular-consent">Oświadczenie osoby wypełniającej formularz: Posiadam zgodę dyrektora placówki na udział zgłaszanego zespołu w programie Solve for Tomorrow. Wzór zgody znajduje się w regulaminie. <span class="star-red">*</span></p>
                    </label>
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/Zgoda_dyrektora_SFT_3_edycja.pdf" target="_blank">(wzór zgody do pobrania).</a>-->
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.team_regulation_consent" />
                      <p class="regular-consent">Posiadam zgody wszystkich pełnoletnich członków i członkiń zespołu (zgodnie z przekaznym wzorem) na zgłoszenie ich do programu Solve for Tomorrow. Wzór zgody znajduje się w regulaminie. <span class="star-red">*</span></p>
                    </label>
                    <h5 class="star-box">Czy zgłaszałeś, zgłaszałaś udział zespołu do programu Solve for Tomorrow w poprzednich edycjach?</h5>
                    <b-form-checkbox-group>
                      <label class="input-control mt-3 align-items-start">
                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 1 edycji" class="label" v-model="schoolForm.editions" />
                        <p class="regular-consent mt-1">Do 1. edycji</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 2 edycji" class="label" v-model="schoolForm.editions" />
                        <p class="regular-consent mt-1">Do 2. edycji</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 3 edycji" class="label" v-model="schoolForm.editions" />
                        <p class="regular-consent mt-1">Do 3. edycji</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Do 1 edycji') || this.schoolForm.editions.includes('Do 2 edycji') || this.schoolForm.editions.includes('Do 3 edycji')" name="edition" value="Nie" class="label" required v-model="schoolForm.editions" />
                        <p class="regular-consent mt-1">Nie zgłaszałem/-am</p>
                      </label>
                    </b-form-checkbox-group>
                    <h5 class="star-box">W jaki sposób dowiedziałeś/dowiedziałaś się o programie Solve for Tomorrow?</h5>
                    <b-form-radio-group required>
                      <label class="input-control mt-3 align-items-start">
                        <input type="radio" name="sft_find_out"  value="W szkole pojawiła się informacja o programie od Samsung (www, social media, pracownicy firmy)" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent">W szkole pojawiła się informacja o programie od Samsung (www, social media, pracownicy firmy)</p>
                      </label>
                      <label class="input-control mt-3 align-items-start">
                        <input type="radio" name="sft_find_out"  value="Mistrzostwa IT w Poznaniu" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent">Mistrzostwa IT w Poznaniu</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="radio" name="sft_find_out"  value="Dzięki konkursowi Explory" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Dzięki konkursowi Explory</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="radio" name="sft_find_out"  value="Konferencja Liczymy się dla edukacji we Wrocławiu" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Konferencja Liczymy się dla edukacji we Wrocławiu</p>
                      </label>
                      <label class="input-control input-control--small-margin align-items-start">
                        <input type="radio" name="sft_find_out"  value="Hackathon NASA Space Apps 2024" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Hackathon NASA Space Apps 2024</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Dzięki SGH" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Dzięki SGH</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Dzięki Gdańsk Model United Nations 2024" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Dzięki Gdańsk Model United Nations 2024</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Konferencja Inspiracje w Warszawie" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Konferencja Inspiracje w Warszawie</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Mail z Kuratorium Oświaty" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Mail z Kuratorium Oświaty</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Od zespołów uczestniczących w ubiegłych edycjach" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Od zespołów uczestniczących w ubiegłych edycjach</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Od innych nauczycieli, nauczycielek, którzy znają program lub brali w nim udział" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Od innych nauczycieli, nauczycielek, którzy znają program lub brali w nim udział</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out"  value="Fundacja Our Future Foundation" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent">Fundacja Our Future Foundation</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Od influencera, influencerki" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Od influencera, influencerki</p>
                      </label>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Od Alumnów Solve for Tomorrow" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Od Alumnów Solve for Tomorrow</p>
                      </label>
                      <div v-if="schoolForm.sft_find_out === 'Od Alumnów Solve for Tomorrow'">
                        <b-input class="mb-4 input" placeholder="Imię i nazwisko" required type="text" v-model="schoolForm.sft_find_out_diffrent"></b-input>
                      </div>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Inne" required v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Inne</p>
                      </label>
                    </b-form-radio-group>
                    <div v-if="schoolForm.sft_find_out === 'Inne'">
                      <b-input class="mb-4 input" placeholder="Wpisz skąd dowiedziałeś/dowiedziałaś o SFT" required type="text" v-model="schoolForm.sft_find_out_diffrent"></b-input>
                    </div>
<!--                    <h5 class="mt-5">Przedstaw krótko swój zespół. Co chciałbyś, żebyśmy o Tobie wiedzieli?</h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea placeholder="Opis zespołu" rows="6" required v-model="schoolForm.about_team"/>-->
<!--                        <p>Opis zespołu</p>-->
<!--                      </div>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(schoolForm.about_team, 150)}}</small>-->
<!--                    </label>-->
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="form-content mt-8">
                <b-row align-h="center">
                  <b-col cols="10" xl="6">
                    <h4 class="form-section-title form-section-title--small-margin red">Wyzwanie Solve for Tomorrow</h4>
                    <p class="regular-big-text text-center">
                      Opowiedz nam o wyzwaniu, które Twój zespół chce podjąć na rzecz społeczności lokalnej
                    </p>
                    <b-row>
                      <b-col cols="12 mt-6">
                        <h5 class="mt-0">W którym z obszarów zespół będzie realizował wyzwanie?</h5>
                        <b-row class="d-flex justify-content-around">
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 1" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 1 }">
                                <svg width="96" height="98" viewBox="0 0 96 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M49.01 98H45.3613V29.3818C45.3613 13.18 55.9303 0 68.8951 0H95.8951V10.4317C95.8587 30.7028 82.6384 47.1779 66.4019 47.1779C61.3303 47.1779 56.4046 45.5987 52.0627 42.6074L53.8262 38.6291C57.6208 41.256 61.9384 42.6377 66.3167 42.6377C80.6559 42.6377 92.2465 28.167 92.2465 10.3709V4.55531H68.8951C57.9249 4.55531 49.01 15.6855 49.01 29.3818V98Z" fill="black"/>
                                    <path d="M40.9101 97.9998H37.2614V44.49C37.2614 34.0887 30.4871 25.631 22.156 25.631H4.33843V29.6549C4.33843 43.2601 13.2047 54.3143 24.0898 54.3143C27.4952 54.3143 30.7912 53.2514 33.6979 51.2471L35.4614 55.2254C32.0195 57.6094 28.1033 58.8545 24.1506 58.8545C11.1979 58.8545 0.701937 45.7807 0.677612 29.7005V21.0605H22.1439C32.4817 21.0605 40.8979 31.5681 40.8979 44.4749V97.9998H40.9101Z" fill="black"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Klimat" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                Klimat
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 2" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 2 }">
                                <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M49.557 75.0407L69.8683 56.733C73.1258 54.1209 74.9821 50.2944 74.9821 46.2273C74.9821 38.6659 68.551 32.5137 60.6468 32.5137C56.2635 32.5137 52.2037 34.404 49.5091 37.5775C46.8145 34.404 42.7666 32.5137 38.3713 32.5137C30.4671 32.5137 24.036 38.6659 24.036 46.2273C24.036 50.3058 25.9162 54.1438 29.1139 56.6986L49.557 75.0407ZM27.6288 46.2273C27.6288 40.5562 32.4552 35.9507 38.3713 35.9507C42.3953 35.9507 46.048 38.0701 47.9043 41.4957L49.4971 44.4286L51.0899 41.4957C52.9462 38.0701 56.5989 35.9507 60.6228 35.9507C66.551 35.9507 71.3653 40.5677 71.3653 46.2273C71.3653 49.2633 69.9641 52.1389 67.4492 54.1667L49.521 70.3205L31.4971 54.1209C29.042 52.1618 27.6288 49.2862 27.6288 46.2273Z" fill="black"/>
                                  <path d="M97.8447 47.3846C96.1201 26.8543 80.683 9.94435 59.9285 5.43044C59.5573 2.38298 56.8866 0 53.6052 0C50.0722 0 47.21 2.74959 47.21 6.11784C47.21 9.48609 50.0842 12.2357 53.6052 12.2357C56.1082 12.2357 58.2639 10.838 59.3177 8.8216C78.4674 13.072 92.683 28.6989 94.2639 47.6596C94.8028 54.1211 93.8686 60.4566 91.4974 66.4714L94.8627 67.6858C97.4136 61.1898 98.4315 54.3617 97.8447 47.3846ZM53.6052 8.79869C52.0603 8.79869 50.8028 7.59574 50.8028 6.11784C50.8028 4.63993 52.0603 3.43699 53.6052 3.43699C55.1501 3.43699 56.4076 4.63993 56.4076 6.11784C56.4076 7.59574 55.1501 8.79869 53.6052 8.79869Z" fill="black"/>
                                  <path d="M86.7784 70.9157C83.2694 70.9157 80.4071 73.6538 80.4071 77.0106C80.4071 78.5344 81.0179 79.9091 81.976 80.9746C74.2514 88.788 63.8682 93.5654 52.6227 94.4247C27.6885 96.3265 5.74843 78.4656 3.74843 54.59C1.88016 32.3641 18.4071 12.0286 41.3652 8.30522L40.7664 4.91406C15.5688 9.00408 -1.88031 30.4738 0.167589 54.865C2.21549 79.3592 23.7125 97.9992 48.97 97.9992C50.2754 97.9992 51.5927 97.9533 52.9221 97.8502C65.2933 96.8993 76.6826 91.5835 85.0658 82.8535C85.6167 83.0024 86.1796 83.1055 86.7784 83.1055C90.2873 83.1055 93.1496 80.3674 93.1496 77.0106C93.1496 73.6424 90.2873 70.9157 86.7784 70.9157ZM86.7784 79.6686C85.2454 79.6686 83.9999 78.4771 83.9999 77.0106C83.9999 75.5442 85.2454 74.3527 86.7784 74.3527C88.3113 74.3527 89.5568 75.5442 89.5568 77.0106C89.5568 78.4771 88.3113 79.6686 86.7784 79.6686Z" fill="black"/>
                                  <path d="M38.8505 85.8225L39.0421 85.8798C48.4194 88.3315 58.2996 87.2546 66.8745 82.8667C85.2577 73.4379 92.2038 51.4641 82.3475 33.8782C72.4912 16.2808 49.5212 9.63596 31.1379 19.0648C18.3954 25.595 10.6709 38.5983 11.2218 52.3692C9.47326 52.9191 7.96428 54.1564 7.23374 55.9207C5.9523 59.0599 7.56907 62.6229 10.8505 63.8487C14.1319 65.0746 17.8565 63.5279 19.1379 60.3774C20.4194 57.2383 18.8026 53.6752 15.5212 52.4494C15.2816 52.3577 15.0421 52.3234 14.8026 52.2546C14.2996 39.7784 21.2936 28.0009 32.8266 22.0893C49.4613 13.5541 70.2637 19.5689 79.1739 35.4821C88.096 51.3954 81.8086 71.2955 65.1739 79.8193C57.4134 83.7947 48.4673 84.7685 40.0242 82.5574L39.8685 82.5116C31.4493 80.0828 24.4074 74.7096 20.0481 67.4003L16.9343 69.1073C21.2457 76.325 27.9284 81.8356 35.9523 84.8487C36.8984 85.2153 37.8685 85.5361 38.8505 85.8225ZM15.7966 59.1286C15.2337 60.5034 13.605 61.1908 12.1679 60.6523C10.7307 60.1139 10.0122 58.5558 10.5751 57.181C11.1379 55.8062 12.7667 55.1188 14.2038 55.6572C15.6529 56.1957 16.3595 57.7538 15.7966 59.1286Z" fill="black"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Zdrowie" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                Zdrowie
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 3" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 3 }">
                                <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M49.9964 67.4961L43.9973 42.3328C47.3808 40.2831 49.5045 36.5936 49.5045 32.5545C49.5045 26.2607 44.4053 21.1484 38.1543 21.1484C31.8913 21.1484 26.8041 26.2727 26.8041 32.5545C26.8041 36.5936 28.9157 40.2952 32.3112 42.3328L26.3121 67.4961H49.9964ZM35.0827 39.7164C32.2272 38.4866 30.3915 35.6773 30.3915 32.5545C30.3915 28.2622 33.8709 24.7656 38.1423 24.7656C42.4136 24.7656 45.893 28.2622 45.893 32.5545C45.893 35.6652 44.0453 38.4866 41.2018 39.7164L39.81 40.3193L45.4251 63.879H30.8594L36.4745 40.3193L35.0827 39.7164Z" fill="black"/>
                                  <path d="M74.4715 52.3892L64.3931 40.1994L61.6216 42.5144L72.7798 56.0063H76.1513L97.9998 31.7594L95.3363 29.3359L74.5555 52.3892H74.4715Z" fill="black"/>
                                  <path d="M72.6965 60.8765C72.6965 61.9979 72.6245 63.1192 72.5045 64.1923L72.4085 64.9519C72.1206 66.9051 71.6047 68.7499 70.9208 70.4861C70.7648 70.884 70.5968 71.2698 70.4169 71.6556C70.2729 71.9691 70.1289 72.2705 69.9849 72.572C69.805 72.9337 69.613 73.3075 69.409 73.6571C69.289 73.8741 69.1571 74.0912 69.0251 74.3082C68.7611 74.7423 68.4852 75.1763 68.1972 75.5983C68.1132 75.7189 68.0292 75.8395 67.9453 75.96C67.5973 76.4423 67.2374 76.9246 66.8654 77.4069C66.7694 77.5275 66.6735 77.648 66.5775 77.7686C66.1455 78.2991 65.7016 78.8176 65.2217 79.324C65.2217 79.324 65.2217 79.336 65.2097 79.336C64.7058 79.8786 64.1778 80.3971 63.6139 80.9276C63.5779 80.9638 63.53 80.9999 63.494 81.0481C62.942 81.5666 62.3541 82.073 61.7542 82.5794C61.7182 82.6156 61.6822 82.6397 61.6343 82.6759C60.4104 83.6887 59.0787 84.6532 57.6509 85.5937C57.6029 85.6299 57.5429 85.666 57.4949 85.6902C56.823 86.1242 56.1271 86.5462 55.4192 86.9682C55.2993 87.0406 55.1793 87.1008 55.0713 87.1732C54.3874 87.5711 53.6915 87.9569 52.9716 88.3307C52.8157 88.4151 52.6717 88.4874 52.5157 88.5718C51.8198 88.9335 51.0999 89.2952 50.356 89.6328C50.1881 89.7172 50.0081 89.7896 49.8401 89.874C49.1082 90.2116 48.3643 90.5492 47.5965 90.8747C47.4165 90.9471 47.2365 91.0194 47.0686 91.0918C46.2887 91.4173 45.4968 91.7308 44.6809 92.0443C44.513 92.1046 44.357 92.1648 44.189 92.2251C43.3372 92.5386 42.4613 92.8521 41.5614 93.1535C41.4534 93.1897 41.3335 93.2259 41.2255 93.2741C40.2176 93.6117 39.1978 93.9372 38.154 94.2507C37.674 94.106 37.1941 93.9614 36.7142 93.8046C36.5822 93.7564 36.4382 93.7202 36.3063 93.672C35.9703 93.5635 35.6344 93.455 35.2864 93.3464C35.0705 93.2741 34.8665 93.2018 34.6505 93.1294C34.3866 93.045 34.1226 92.9486 33.8706 92.8642C33.6187 92.7798 33.3667 92.6833 33.1148 92.5868C32.8988 92.5024 32.6708 92.4301 32.4549 92.3457C32.1669 92.2372 31.891 92.1287 31.603 92.0322C31.411 91.9599 31.2311 91.8875 31.0391 91.8152C30.7271 91.6946 30.4152 91.574 30.1032 91.4414C29.9473 91.3811 29.7913 91.3088 29.6353 91.2485C29.2994 91.1159 28.9634 90.9712 28.6275 90.8265C28.4955 90.7783 28.3755 90.718 28.2435 90.6698C27.8836 90.513 27.5236 90.3563 27.1637 90.1995C27.0797 90.1634 26.9957 90.1151 26.8997 90.079C26.5038 89.8981 26.1079 89.7172 25.7239 89.5364C25.6879 89.5243 25.6519 89.5002 25.6159 89.4882C22.9284 88.198 20.3008 86.7391 17.8652 85.0752C17.8292 85.0511 17.8052 85.027 17.7692 85.015C17.4332 84.7859 17.1093 84.5568 16.7853 84.3156C16.6894 84.2433 16.5814 84.171 16.4854 84.0986C16.1974 83.8936 15.9215 83.6766 15.6455 83.4596C15.5015 83.3511 15.3696 83.2425 15.2376 83.134C14.9976 82.9411 14.7457 82.7362 14.5057 82.5432C14.3377 82.4106 14.1818 82.2659 14.0138 82.1333C13.7978 81.9524 13.5939 81.7716 13.3899 81.5787C13.2099 81.4099 13.0179 81.2411 12.838 81.0723C12.658 80.9035 12.478 80.7347 12.2981 80.5659C12.0941 80.3729 11.8901 80.168 11.6981 79.963C11.5542 79.8183 11.3982 79.6616 11.2542 79.5048C11.0263 79.2637 10.8103 79.0225 10.5943 78.7814C10.4863 78.6608 10.3664 78.5282 10.2584 78.3956C10.0064 78.1062 9.76646 77.8168 9.52649 77.5154C9.4545 77.431 9.38252 77.3345 9.31053 77.2501C9.02257 76.8884 8.74662 76.5147 8.48266 76.1409C8.44666 76.1047 8.42267 76.0686 8.39867 76.0444C6.61095 73.5124 5.25517 70.7031 4.4393 67.5924C4.4273 67.5562 4.4273 67.52 4.4153 67.4839C4.29532 67.0257 4.18734 66.5555 4.10335 66.0852C4.07935 65.9767 4.06736 65.8682 4.04336 65.7597C3.75541 64.1923 3.59943 62.5766 3.59943 60.8765V12.1415L38.142 3.7136L72.6845 12.1415V43.5263H76.2839V9.29606L38.142 0L0 9.29606V60.8765C0 62.444 0.107983 63.9873 0.335947 65.4824V65.4944C0.467926 66.3625 0.635899 67.2186 0.839867 68.0626C0.851865 68.1229 0.863863 68.1832 0.88786 68.2435C1.10383 69.0875 1.35579 69.9315 1.63174 70.7513C1.64374 70.7875 1.65574 70.8116 1.66774 70.8478C5.27917 81.1325 14.7577 89.3796 29.6473 95.143C29.7313 95.1791 29.8153 95.2032 29.8993 95.2394C31.0631 95.6855 32.2509 96.1196 33.4747 96.5295C33.5947 96.5657 33.7147 96.6019 33.8347 96.6501C35.0585 97.0601 36.3183 97.4579 37.6141 97.8438C37.626 97.8438 37.638 97.8558 37.65 97.8558L38.154 98.0005L38.6579 97.8558C38.6939 97.8438 38.7299 97.8317 38.7539 97.8196C40.0497 97.4338 41.3095 97.0359 42.5333 96.626C42.7732 96.5416 43.0012 96.4572 43.2292 96.3848C44.309 96.0111 45.3768 95.6252 46.4087 95.2394C46.5166 95.1912 46.6366 95.155 46.7446 95.1068C61.3103 89.464 70.6088 81.5425 74.4122 71.4386L74.3882 71.4266C75.1201 69.4974 75.66 67.52 75.972 65.4462L76.08 64.6384C76.2239 63.4085 76.3079 62.1425 76.3079 60.8765V60.2134H72.7085V60.8765H72.6965Z" fill="black"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Bezpieczeństwo" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                Bezpieczeństwo
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 4" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 4 }">
                                <svg width="94" height="98" viewBox="0 0 94 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.72681 62.2404C8.72681 71.5457 12.3081 80.3602 18.8016 87.0643C25.2262 93.6998 33.8154 97.5573 42.9948 97.9598V97.999H45.8972L46.1432 97.9696C55.3325 97.5573 63.9216 93.6998 70.3364 87.0643C76.8299 80.3602 80.4112 71.5457 80.4112 62.2404V60.6699H8.72681V62.2404V62.2404ZM11.9145 63.8109H43.0047V94.8286C26.2986 94.0335 12.7115 80.478 11.9145 63.8109ZM46.153 94.8286V63.8109H77.2431C76.4462 80.478 62.859 94.0335 46.153 94.8286V94.8286Z" fill="black"/>
                                  <path d="M37.4164 17.0996H35.8422C16.0763 17.0996 0 33.1385 0 52.8582V54.4287H37.4164V17.0996ZM34.268 20.2799V51.2975H3.18772C3.98465 34.6305 17.5718 21.075 34.2778 20.2799H34.268Z" fill="black"/>
                                  <path d="M57.6447 0H56.0706V37.3291H93.4869V35.7586C93.4869 16.0389 77.4106 0 57.6447 0ZM59.2189 34.1881V3.18029C75.9249 3.97536 89.5121 17.5308 90.309 34.1979H59.2189V34.1881Z" fill="black"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Integracja" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                Integracja
                              </div>
                            </label>
                          </div>
                        </b-row>
                        <h5 class="">Jakie wyzwania zidentyfikowaliście? Opiszcie problem, który zaobserwowaliście w swoim otoczeniu (np. w szkole, wśród społeczności lokalnej, w swojej miejscowości).</h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="6" v-model="schoolForm.team_challenges"></b-textarea>
<!--                            <p>Opisz Wasze wyzwania</p>-->
                          </div>
                          <small class="maxlength-label">{{getWordsLeft(schoolForm.team_challenges, 350, 'team_challenges')}}</small>
                        </label>
<!--                        <small class="maxlength-label">Opiszcie problem, który zaobserwowaliście w swoim otoczeniu (np. w szkole, wśród społeczności lokalnej, w swojej miejscowości).</small>-->
                        <h5 class="">Opowiedz o Waszym pomyśle na rozwiązanie problemu opisanego powyżej. Na czym on polega i co może zmienić. Jaki byłby pozytywny wpływ rozwiązania, które proponujecie w perspektywie krótko- i długoterminowej?</h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="3" v-model="schoolForm.team_idea_short_description"></b-textarea>
<!--                            <p>Przedstaw pomysł</p>-->
                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_idea_short_description, 300, 'team_idea_short_description')}}</small>
                          </div>
                        </label>
    <!--                    <h5 class="mt-5 mb-4">-->
    <!--                      Opowiedz nam więcej o Waszym wyzwaniu (lub pomyśle). Co się stanie, jeśli nic się nie zmieni?-->
    <!--                      Jaki byłby pozytywny wpływ rozwiązania, które proponujecie w perspektywie krótko- i długoterminowej?-->
    <!--                    </h5>-->
    <!--                    <label class="w-100">-->
    <!--                      <div class="input-box">-->
    <!--                        <b-textarea required placeholder="Opisz Wasze wyzwanie/pomysł" rows="6" v-model="schoolForm.team_idea_description"></b-textarea>-->
    <!--                        <p>Opisz Wasze wyzwanie/pomysł</p>-->
    <!--                        <small class="maxlength-label">{{getWordsLeft(schoolForm.team_idea_description, 300)}}</small>-->
    <!--                      </div>-->
    <!--                    </label>-->
                        <h5 class="">
                          Kogo dotyczy proponowane przez Wasz zespół rozwiązanie? Opisz grupę docelową.
                        </h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="4" v-model="schoolForm.team_target"></b-textarea>
<!--                            <p>Opisz grupę docelową</p>-->
                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_target, 100, 'team_target')}}</small>
                          </div>
                        </label>
                        <h5 class="mt-5">
                          Sojusznicy. Z kim możesz współpracować, kogo poprosić o radę, pomoc, wsparcie, aby zrealizować swój pomysł, odpowiedzieć na postawione wyzwanie i wprowadzić zmiany? [max 100 słów]
                        </h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="4" v-model="schoolForm.team_ally"></b-textarea>
<!--                            <p>Opisz sojusznika</p>-->
                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_ally, 100, 'team_ally')}}</small>
                          </div>
                        </label>
    <!--                    <h5 class="mt-5 mb-4">-->
    <!--                      Jakie są 3 najważniejsze rzeczy, których Twój zespół chciałby się nauczyć, aby zrealizować postawione wyzwanie i odpowiedzieć-->
    <!--                      na zidentyfikowane potrzeby w swojej społeczności lokalnej?-->
    <!--                    </h5>-->
    <!--                    <div class="input-box">-->
    <!--                      <b-textarea required placeholder="Wypisz 3 rzeczy" rows="3" v-model="schoolForm.team_goal"></b-textarea>-->
    <!--                      <p>Wypisz 3 rzeczy</p>-->
    <!--                    </div>-->
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title">I ostatnie pytanie...</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12">-->
<!--                    <h5 class="mt-5 mb-4">Skąd dowiedziałeś/dowiedziałaś się o Solve for Tomorrow?</h5>-->
<!--                    <b-form-radio-group>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Strona Samsung" value="Strona Samsung" v-model="schoolForm.sft_find_out" />-->
<!--                        Strona Samsung-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input id="Media" type="radio" name="Media" value="Media" v-model="schoolForm.sft_find_out" />-->
<!--                        Media-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="E-mail do szkoły" value="E-mail do szkoły" v-model="schoolForm.sft_find_out" />-->
<!--                        E-mail do szkoły-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Facebook" value="Facebook" v-model="schoolForm.sft_find_out" />-->
<!--                        Facebook-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Kuratorium Oświaty" value="Kuratorium Oświaty" v-model="schoolForm.sft_find_out" />-->
<!--                        Kuratorium Oświaty-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Grupy nauczycielskie na Facebooku" value="Grupy nauczycielskie na Facebooku" v-model="schoolForm.sft_find_out" />-->
<!--                        Grupy nauczycielskie na Facebooku-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Przez szkołę" value="Przez szkołę" v-model="schoolForm.sft_find_out" />-->
<!--                        Przez szkołę-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Inne" value="Inne" v-model="schoolForm.sft_find_out" />-->
<!--                        Inne-->
<!--                      </label>-->
<!--                    </b-form-radio-group>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
            </b-row>
            <b-row v-else-if="currentStep === 1">
              <b-col class="mt-5">
                <p class="text-18 text-center">
                  Aplikacja wypełniona!<br>
                  Teraz chcemy się tylko upewnić, że przeczytałeś/przeczytałaś regulamin.
                  <br>
                  Poprosimy Cię także o zaznaczenie zgód.
                </p>
                <p class="text-18 text-center">Pozostał Ci już tylko ostatni krok, jakim jest wysłanie zgłoszenia.</p>
                <div class="consent-box mt-6">
                  <b-row align-h="center">
                    <b-col cols="6">
                      <h4 class="mt-0 mb-0 text-center form-section-title yellow">Regulamin</h4>
                      <label class="input-control d-flex align-items-start mt-7">
                        <input class="mt-1" type="checkbox" required v-model="schoolForm.regulation_consent" />
                        <p class="mb-0">Oświadczam, że zapoznałem/zapoznałam się z <a href="https://solvefortomorrow.pl/wp-content/uploads/2024/09/regulamin_Solve_for_Tomorrow_PL_4.pdf" target="_blank">regulaminem</a> programu. <span class="color-span">*</span></p>
                      </label>
                    </b-col>
                  </b-row>
                </div>
<!--                <b-checkbox class="mb-3" required v-model="schoolForm.regulation_consent">Oświadczam, że zapoznałem/zapoznałam się z regulaminem programu i akceptuję jego postanowienia.</b-checkbox>-->
<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="schoolForm.team_regulation_consent" />-->
<!--                  Oświadczam, że zapoznałem/zapoznałam z regulaminem programu wszystkich członków i członkinie mojego zespołu. Wszyscy zaakceptowali jego postanowienia.-->
<!--                </label>-->
<!--                <b-checkbox required v-model="schoolForm.team_regulation_consent">Oświadczam, że zapoznałem/zapoznałam z regulaminem programu wszystkich członków i członkinie mojego zespołu. Wszyscy zaakceptowali jego postanowienia.</b-checkbox>-->
<!--                <h4 class="mt-5 mb-4 text-center">Zgody</h4>-->
<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="schoolForm.personal_data_consent" />-->
<!--                  <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow.<span class="color-span">*</span></p>-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">(do pobrania TUTAJ)</a>-->
<!--                  i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
<!--                </label>-->
<!--                <b-checkbox class="mb-3" required v-model="schoolForm.personal_data_consent">-->
<!--                  Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. Posiadam wypełnione i podpisane oświadczenie-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">(do pobrania TUTAJ)</a>-->
<!--                  i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
<!--                </b-checkbox>-->
                <div class="consent-box mt-6">
                  <b-row align-h="center">
                    <b-col cols="6">
                      <h4 class="mt-0 mb-0 text-center form-section-title blue mb-7">Zgody</h4>
                      <label class="input-control d-flex align-items-start mt-0">
                        <input type="checkbox" required v-model="schoolForm.personal_data_consent" />
                        <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych w celach związanych z udziałem w programie Solve for Tomorrow. Treść zgody znajduje się w regulaminie programu.<span class="color-span">*</span></p>
<!--                          <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. Posiadam wypełnione i podpisane oświadczenie-->
<!--                            <a href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/SFT_RODO_dziecko_3_edycja.pdf" target="_blank">(uczestnik niepełnoletni)/</a>-->
<!--                            <a href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/SFT_RODO_uczestnik_pelnoletni_3_edycja.pdf" target="_blank">(uczestnik pełnoletni)</a>-->
<!--                            i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.<span class="color-span">*</span></p>-->
                      </label>
<!--                      <label class="input-control d-flex align-items-start">-->
<!--                        <input class="mb-2" type="checkbox" required v-model="schoolForm.personal_image_consent" />-->
<!--                        <p class="mb-0">Wyrażam zgodę na wykorzystanie mojego wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. <span class="color-span">*</span></p>-->
<!--                      </label>-->
                    </b-col>
                  </b-row>
                </div>

<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="schoolForm.personal_image_consent" />-->
<!--                  Posiadam wypełnione i podpisane zgody na przetwarzanie danych osobowych i wizerunku (-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">do pobrania TUTAJ zgoda dla osoby pełnoletniej</a> i <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_dziecko.pdf" target="_blank">dla osoby niepełnoletniej)</a> od wszystkich członków i członkiń mojego zespołu (w przypadku osób niepełnoletnich podpisane przez rodziców/opiekunów prawnych) i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
<!--                </label>-->
<!--                <b-checkbox required v-model="schoolForm.personal_image_consent">Posiadam wypełnione i podpisane zgody na przetwarzanie danych osobowych i wizerunku (-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">do pobrania TUTAJ zgoda dla osoby pełnoletniej</a> i <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_dziecko.pdf" target="_blank">dla osoby niepełnoletniej)</a> od wszystkich członków i członkiń mojego zespołu (w przypadku osób niepełnoletnich podpisane przez rodziców/opiekunów prawnych) i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
<!--                </b-checkbox>-->
<!--                <p class="text-center mt-6">-->
<!--                  Pozostał Ci już tylko ostatni krok, jakim jest wysłanie zgłoszenia.<br>-->
<!--                </p>-->
              </b-col>
            </b-row>
            <b-row v-else-if="currentStep === 2">
              <b-col class="text-center mt-6">
                <h3 class="final-text" v-if="!errorAlert">Dziękujemy za wypełnienie formularza!<br><br>
                  Twoje zgłoszenie już do nas trafiło.<br>
                  Teraz potrzebujemy trochę czasu na jego analizę.<br><br>
                  Do usłyszenia!
                </h3>
                <h3 v-else>
                  Ups... Coś poszło nie tak!<br />
                  Spróbuj ponownie później!
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.wordsLimitIdea || this.wordsTeamChallenge || this.wordsTeamTarget || this.wordsTeamAlly">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Jedno z pól przekracza dostępną liczbę słów.
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.emptyFields">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Nie wypełniono wszystkich pól lub są błędnie wypełnione!
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.validEmail">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Jedno z pól email nie posiada poprawnego adresu email
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="currentStep < 2" class="mt-6 mb-3 d-inline-flex justify-content-end" :class="[currentStep > 0 ? 'justify-content-between' : '']">
                <b-button v-if="currentStep > 0" @click="currentStep--" class="button-new-primary button-new-primary--left" variant="info">
                  <svg v-if="currentStep === 1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12.5L19 12.5M5 12.5L11 18.5M5 12.5L11 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Wróć do kroku 1
                </b-button>
                <b-button class="ml-4 button-new-primary" type="submit" variant="primary">
                  <span>{{currentStep === 0 ? 'Krok 2' : 'Wyślij zgłoszenie' }}</span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12.5L5 12.5M19 12.5L13 18.5M19 12.5L13 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </b-button>
              </b-col>
              <b-col v-else class="mt-6 mb-3 text-center">
                <router-link class="d-flex justify-content-center w-100 text-decoration-none" to="/"><b-button class="button-new-primary button-new-primary--big" variant="primary">Wróć na stronę główną SFT</b-button></router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
<!--      <b-container v-else-if="formSelected === 'university'">-->
<!--        <b-row>-->
<!--          <b-col class="text-center">-->
<!--            <h3>Formularz zgłoszeniowy do programu Solve for Tomorrow dla opiekuna/opiekunki zespołu</h3>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        <b-row>-->
<!--          <b-col cols="12" lg="6" offset-lg="3">-->
<!--            <b-row class="hr_container mt-5">-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 0},{finished: currentStep > 0}]">01.</div>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 1},{finished: currentStep > 1}]">02.</div>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 2},{finished: currentStep > 2}]">03.</div>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class=" mt-2 text-center">-->
<!--              <b-col cols="4">-->
<!--                <p>Aplikacja</p>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <p>Regulamin, zgody i oświadczenia</p>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <p>Potwierdzenie</p>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-if="currentStep === 0">-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title yellow">Informacje o Tobie</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <b-input class="mb-4" required placeholder="Imię" v-model="universityForm.first_name"></b-input>-->
<!--                    <b-input class="mb-4" required placeholder="Nazwisko" v-model="universityForm.last_name"></b-input>-->
<!--                    <b-input class="mb-4" required type="email" placeholder="Adres e-mail" v-model="universityForm.email"></b-input>-->
<!--                    <b-input class="mb-4" required placeholder="Numer telefonu" v-model="universityForm.phone"></b-input>-->
<!--                    <b-checkbox required v-model="universityForm.team_register_consent">-->
<!--                      Posiadam zgody wszystkich członków i członkiń zespołu na zgłoszenie ich do programu Solve for Tomorrow.-->
<!--                    </b-checkbox>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title blue">Informacje o zespole</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <b-input class="mb-4" required placeholder="Nazwa uczelni" v-model="universityForm.school_name"></b-input>-->
<!--                    <h5 class="mt-5 mb-4">Adres uczelni</h5>-->
<!--                    <b-select class="mb-4" required :options="voivodeships" v-model="universityForm.school_voivodeship">-->
<!--                      <template #first>-->
<!--                        <b-select-option value="" disabled>Województwo</b-select-option>-->
<!--                      </template>-->
<!--                    </b-select>-->
<!--                    <b-input class="mb-4" required placeholder="Ulica" v-model="universityForm.school_street"></b-input>-->
<!--                    <b-row>-->
<!--                      <b-col cols="12" lg="4">-->
<!--                        <b-input class="mb-4 w-100" required placeholder="Kod pocztowy" v-model="universityForm.school_zip"></b-input>-->
<!--                      </b-col>-->
<!--                      <b-col>-->
<!--                        <b-input class="mb-4 w-100" required placeholder="Miejscowość" v-model="universityForm.school_city"></b-input>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
<!--                    <h5 class="mt-5 mb-4">Liczba osób w zespole (wraz z liderem/liderką)</h5>-->
<!--                    <div class="d-flex justify-content-around">-->
<!--                      &lt;!&ndash;                    <div class="team-size-btn" @click="teamSize=3" :class="{active: teamSize === 3}">&ndash;&gt;-->
<!--                      &lt;!&ndash;                      <img src="../../assets/media/icons/three-people.svg"/>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      <p class="mb-0 mt-2">3 osoby</p>&ndash;&gt;-->
<!--                      &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                      <div class="team-size-btn" @click="teamSize=4" :class="{active: teamSize === 4}">-->
<!--                        <img src="../../assets/media/icons/four-people.svg"/>-->
<!--                        <p class="mb-0 mt-2">4 osoby</p>-->
<!--                      </div>-->
<!--                      <div class="team-size-btn" @click="teamSize=5" :class="{active: teamSize === 5}">-->
<!--                        <img src="../../assets/media/icons/five-people.svg"/>-->
<!--                        <p class="mb-0 mt-2">5 osoby</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <h5 class="my-4">Imiona i nazwiska wszystkich członków zespołu (bez opiekuna/opiekunki w przypadku zespołów uczniowskich)</h5>-->
<!--                    <b-row class="mb-4" v-for="index in teamSize-1" :key="index">-->
<!--                      <b-col>-->
<!--                        <b-input required placeholder="Imię" v-model="universityForm.team_members.first_names[index]"></b-input>-->
<!--                      </b-col>-->
<!--                      <b-col>-->
<!--                        <b-input required placeholder="Nazwisko" v-model="universityForm.team_members.last_names[index]"></b-input>-->
<!--                      </b-col>-->
<!--                      <b-col cols="3">-->
<!--                        <b-input required placeholder="Wiek" type="number" v-model="universityForm.team_members.ages[index]"></b-input>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
<!--                    <h5 class="mt-5 mb-4">Przedstaw krótko swój zespół. Co chciałbyś, żebyśmy o Tobie wiedzieli?</h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea placeholder="Opis zespołu" required v-model="universityForm.about_team"/>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.about_team, 150)}}</small>-->
<!--                    </label>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title red">Wyzwanie Solve for Tomorrow</h4>-->
<!--                <p class="text-center">-->
<!--                  Opowiedz nam o wyzwaniu, które Twój zespół chce podjąć na rzecz społeczności lokalnej-->
<!--                </p>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <h5 class="mt-5 mb-4">W którym z obszarów zespół będzie realizował wyzwanie?</h5>-->
<!--                    <b-row class="d-flex justify-content-around">-->
<!--                      <label class="col text-center">-->
<!--                        <img src="../../assets/media/icons/plant.svg"/>-->
<!--                        <b-radio class="mt-3" value="klimat" v-model="universityForm.team_subject_challenge">Klimat</b-radio>-->
<!--                      </label>-->
<!--                      <label class="col text-center">-->
<!--                        <img src="../../assets/media/icons/heart.svg"/>-->
<!--                        <b-radio class="mt-3" value="Zdrowie" v-model="universityForm.team_subject_challenge">Zdrowie</b-radio>-->
<!--                      </label>-->
<!--                      <label class="col text-center">-->
<!--                        <img src="../../assets/media/icons/shield.svg"/>-->
<!--                        <b-radio class="mt-3" value="Bezpieczeństwo" v-model="universityForm.team_subject_challenge">Bezpieczeństwo</b-radio>-->
<!--                      </label>-->
<!--                    </b-row>-->
<!--                    <h5 class="mt-5 mb-4">Jakie wyzwania zidentyfikowaliście i dlaczego jest ono dla Was ważne?</h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea required placeholder="Opisz Wasze wyzwania" v-model="universityForm.team_challenges"></b-textarea>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_challenges, 300)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">Przykuj naszą uwagę. W atrakcyjny i krótki sposób przedstaw swoje wyzwanie.</h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea required placeholder="Przedstaw swoje wyzwanie" v-model="universityForm.team_idea_short_description"></b-textarea>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_idea_short_description, 30)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Opowiedz nam więcej o Waszym wyzwaniu (lub pomyśle). Co się stanie, jeśli nic się nie zmieni?-->
<!--                      Jaki byłby pozytywny wpływ rozwiązania, które proponujecie w perspektywie krótko- i długoterminowej?-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea required placeholder="Opisz Wasze wyzwanie/pomysł" v-model="universityForm.team_idea_description"></b-textarea>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_idea_description, 300)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Kogo dotyczy proponowane przez Wasz zespół rozwiązanie? Opisz grupę docelową.-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea required placeholder="Opisz grupę docelową" v-model="universityForm.team_target"></b-textarea>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_target, 100)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Sojusznicy. Z kim możesz współpracować, kogo poprosić o radę, pomoc, wsparcie, aby zrealizować swój pomysł, odpowiedzieć na postawione wyzwanie i wprowadzić zmiany?-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <b-textarea required placeholder="Opisz sojusznika" v-model="universityForm.team_ally"></b-textarea>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_ally, 100)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Jakie są 3 najważniejsze rzeczy, których Twój zespół chciałby się nauczyć, aby zrealizować postawione wyzwanie i odpowiedzieć-->
<!--                      na zidentyfikowane potrzeby w swojej społeczności lokalnej?-->
<!--                    </h5>-->
<!--                    <b-textarea required placeholder="Wypisz 3 rzeczy" v-model="universityForm.team_goal"></b-textarea>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title">I ostatnie pytanie...</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12">-->
<!--                    <h5 class="mt-5 mb-4">Skąd dowiedziałeś/dowiedziałaś się o Solve for Tomorrow?</h5>-->
<!--                    <b-radio-group>-->
<!--                      <b-radio class="d-block mb-3" value="Strona Samsung" v-model="universityForm.sft_find_out">Strona Samsung</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="Media" v-model="universityForm.sft_find_out">Media</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="E-mail do szkoły" v-model="universityForm.sft_find_out">E-mail do szkoły</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="Facebook" v-model="universityForm.sft_find_out">Facebook</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="Grupy nauczycielskie na Facebooku" v-model="universityForm.sft_find_out">Grupy nauczycielskie na Facebooku</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="Przez szkołę" v-model="universityForm.sft_find_out">Przez szkołę</b-radio>-->
<!--                      <b-radio class="d-block mb-3" value="Inne" v-model="universityForm.sft_find_out">Inne</b-radio>-->
<!--                    </b-radio-group>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-else-if="currentStep === 1">-->
<!--              <b-col class="mt-5">-->
<!--                <p class="text-center">-->
<!--                  Aplikacja wypełniona!<br>-->
<!--                  Teraz chcemy się tylko upewnić, że przeczytałeś/przeczytałaś regulamin.-->
<!--                  <br>-->
<!--                  Poprosimy Cię także o zaznaczenie zgód.-->
<!--                  Pozostał Ci już tylko ostatni krok, jakim jest wysłanie zgłoszenia.<br>-->
<!--                </p>-->
<!--                <h5 class="mt-5 mb-4">Regulamin</h5>-->
<!--                <b-checkbox class="mb-3" required v-model="universityForm.regulation_consent">Oświadczam, że zapoznałem/zapoznałam się z regulaminem programu i akceptuję jego postanowienia.</b-checkbox>-->
<!--                <b-checkbox required v-model="universityForm.team_regulation_consent">Oświadczam, że zapoznałem/zapoznałam z regulaminem programu wszystkich członków i członkinie mojego zespołu. Wszyscy zaakceptowali jego postanowienia.</b-checkbox>-->
<!--                <h5 class="mt-5 mb-4">Zgody</h5>-->
<!--                <b-checkbox class="mb-3" required v-model="universityForm.personal_data_consent">-->
<!--                  Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. Posiadam wypełnione i podpisane oświadczenie-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">(do pobrania TUTAJ)</a>-->
<!--                  i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
<!--                </b-checkbox>-->
<!--                <b-checkbox required v-model="universityForm.personal_image_consent">Posiadam wypełnione i podpisane zgody na przetwarzanie danych osobowych i wizerunku (-->
<!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">do pobrania TUTAJ zgoda dla osoby pełnoletniej</a> i <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_dziecko.pdf" target="_blank">dla osoby niepełnoletniej)</a> od wszystkich członków i członkiń mojego zespołu (w przypadku osób niepełnoletnich podpisane przez rodziców/opiekunów prawnych) i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.</b-checkbox>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-else-if="currentStep === 2">-->
<!--              <b-col class="text-center my-5">-->
<!--                <h3>Dziękujemy za wypełnienie formularza!<br>-->
<!--                  Twoje zgłoszenie już do nas trafiło.-->
<!--                  Teraz potrzebujemy trochę czasu na jego analizę.<br>-->
<!--                  Do usłyszenia!</h3>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--              <b-col v-if="currentStep < 2" class="mt-5 mb-3 d-inline-flex justify-content-end">-->
<!--                <b-button v-if="currentStep > 0" @click="currentStep&#45;&#45;" variant="info">Wróć</b-button>-->
<!--                <b-button class="ml-4" type="submit" variant="primary">Dalej</b-button>-->
<!--              </b-col>-->
<!--              <b-col v-else class="mt-5 mb-3 text-center">-->
<!--                <router-link to="/"><b-button variant="primary">Wróć na stronę główną</b-button></router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        END-->
<!--        <b-row>-->
<!--          <b-col class="text-center">-->
<!--            <h3>Formularz zgłoszeniowy do programu Solve for Tomorrow dla opiekuna/opiekunki zespołu</h3>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        <b-row>-->
<!--          <b-col cols="12" lg="6" offset-lg="3">-->
<!--            <b-row class="hr_container mt-5">-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 0},{finished: currentStep > 0}]">01.</div>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 1},{finished: currentStep > 1}]">02.</div>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <div class="number"  :class="[{active: currentStep === 2},{finished: currentStep > 2}]">03.</div>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class=" mt-2 text-center">-->
<!--              <b-col cols="4">-->
<!--                <p>Aplikacja</p>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <p>Regulamin, zgody i oświadczenia</p>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <p>Potwierdzenie</p>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-if="currentStep === 0">-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title yellow">Informacje o Tobie</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Imię i nazwisko *" v-model="universityForm.first_name"></b-input>-->
<!--                      <p>Imię i nazwisko <span class="color">*</span></p>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;                    <b-input class="mb-4" required placeholder="Nazwisko" v-model="schoolForm.last_name"></b-input>&ndash;&gt;-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" placeholder="Adres e-mail *" required type="email" v-model="universityForm.email"></b-input>-->
<!--                      <p>Adres e-mail <span class="color">*</span></p>-->
<!--                    </div>-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Numer telefonu *" v-model="universityForm.phone"></b-input>-->
<!--                      <p>Numer telefonu <span class="color">*</span></p>-->
<!--                    </div>-->
<!--                    <h5 class="mt-5 mb-4">Jakiego przedmiotu/przedmiotów uczysz?</h5>-->
<!--                    <div class="input-box">-->
<!--                      <b-textarea class="input" rows="4" required placeholder="Wypisz przedmiot/-y" v-model="universityForm.subjects"></b-textarea>-->
<!--                      <p>Wypisz przedmiot/-y</p>-->
<!--                    </div>-->
<!--                    <h5 class="mt-5 mb-4">Twoja główna funkcja w szkole</h5>-->
<!--                    <b-select class="mb-4" required :options="teacherRoles" v-model="universityForm.role">-->
<!--                      <template #first>-->
<!--                        <b-select-option value="" disabled>Wybierz</b-select-option>-->
<!--                      </template>-->
<!--                    </b-select>-->
<!--                    <label class="input-control">-->
<!--                      <input type="checkbox" class="label" required v-model="universityForm.director_consent" />-->
<!--                      Posiadam zgodę dyrektora placówki na udział zgłaszanego zespołu w programie Solve for Tomorrow-->
<!--                    </label>-->
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2022/09/Zgoda_dyrektora_SFT_2_edycja.pdf" target="_blank">(wzór zgody do pobrania).</a>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title blue">Informacje o zespole</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Nazwa placówki" v-model="universityForm.school_name"></b-input>-->
<!--                      <p>Nazwa placówki</p>-->
<!--                    </div>-->
<!--                    <h5 class="mt-5 mb-4 input">Adres placówki</h5>-->
<!--                    <b-select class="mb-4 input select" required :options="voivodeships" v-model="universityForm.school_voivodeship">-->
<!--                      <template #first>-->
<!--                        <b-select-option :value="null" class="select" disabled>Województwo</b-select-option>-->
<!--                      </template>-->
<!--                    </b-select>-->
<!--                    <div class="input-box">-->
<!--                      <b-input class="mb-4 input" required placeholder="Ulica" v-model="universityForm.school_street"></b-input>-->
<!--                      <p>Ulica</p>-->
<!--                    </div>-->
<!--                    <b-row>-->
<!--                      <b-col cols="12" lg="4">-->
<!--                        <div class="input-box">-->
<!--                          <b-input class="mb-4 w-100 input" required placeholder="Kod pocztowy" v-model="universityForm.school_zip"></b-input>-->
<!--                          <p>Kod pocztowy</p>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                      <b-col>-->
<!--                        <div class="input-box">-->
<!--                          <b-input class="mb-4 w-100 input" required placeholder="Miejscowość" v-model="universityForm.school_city"></b-input>-->
<!--                          <p>Miejscowość</p>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
<!--                    <h5 class="mt-5 mb-4">Liczba osób w zespole (wraz z opiekunem/opiekunką) *</h5>-->
<!--                    <div class="d-flex justify-content-around">-->
<!--                      <div class="team-size-btn" @click="teamSize=3" :class="{active: teamSize === 3}">-->
<!--                        <img src="../../assets/media/icons/three-people.svg"/>-->
<!--                        <p class="mb-0 mt-2">3 osoby</p>-->
<!--                      </div>-->
<!--                      <div class="team-size-btn" @click="teamSize=4" :class="{active: teamSize === 4}">-->
<!--                        <img src="../../assets/media/icons/four-people.svg"/>-->
<!--                        <p class="mb-0 mt-2">4 osoby</p>-->
<!--                      </div>-->
<!--                      <div class="team-size-btn" @click="teamSize=5" :class="{active: teamSize === 5}">-->
<!--                        <img src="../../assets/media/icons/five-people.svg"/>-->
<!--                        <p class="mb-0 mt-2">5 osoby</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <h5 class="my-4 star-box">Imiona i nazwiska wszystkich członków zespołu (tylko uczniowie) <span class="color">*</span></h5>-->
<!--                    <b-row class="mb-4" v-for="index in teamSize - 1" :key="index">-->
<!--                      <b-col>-->
<!--                        <div class="input-box">-->
<!--                          <b-input required placeholder="Imię" v-model="universityForm.team_members[index - 1].firstname"></b-input>-->
<!--                          <p>Imię</p>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                      <b-col>-->
<!--                        <div class="input-box">-->
<!--                          <b-input required placeholder="Nazwisko" v-model="universityForm.team_members[index - 1].lastname"></b-input>-->
<!--                          <p>Nazwisko</p>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                      <b-col cols="3">-->
<!--                        <p class="star">*</p>-->
<!--                        <div class="input-box">-->
<!--                          <b-input required placeholder="Wiek" type="number" v-model="universityForm.team_members[index - 1].age"></b-input>-->
<!--                          <p>Wiek</p>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
<!--                    <b-row class="mb-4">-->
<!--                      <p>* (Wiek w chwili wypełniania formularza)</p>-->
<!--                    </b-row>-->
<!--                    <label class="input-control">-->
<!--                      <input type="checkbox" class="mb-4 label" required v-model="universityForm.parental_consent" />-->
<!--                      Posiadam zgodę rodzica lub prawnego opiekuna dla wszystkich niepełnoletnich członków zespołu-->
<!--                      i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow-->
<!--                    </label>-->
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2022/09/Zgoda_na_udzial_dziecka_w-programie_SFT_2_edycja.pdf" target="_blank">(wzór zgody do pobrania).</a>-->
<!--                    <h5 class="mt-5 mb-4">Przedstaw krótko swój zespół. Co chciałbyś, żebyśmy o Tobie wiedzieli?</h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea placeholder="Opis zespołu" rows="6" required v-model="universityForm.about_team"/>-->
<!--                        <p>Opis zespołu</p>-->
<!--                      </div>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.about_team, 150)}}</small>-->
<!--                    </label>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title red">Wyzwanie Solve for Tomorrow</h4>-->
<!--                <p class="text-center">-->
<!--                  Opowiedz nam o wyzwaniu, które Twój zespół chce podjąć na rzecz społeczności lokalnej-->
<!--                </p>-->
<!--                <b-row>-->
<!--                  <b-col cols="12 mt-5">-->
<!--                    <h5 class="mt-5 mb-4">W którym z obszarów zespół będzie realizował wyzwanie?</h5>-->
<!--                    <b-row class="d-flex justify-content-around">-->
<!--                      <label @click="activeIndex = 1" class="col text-center box input-control img">-->
<!--                        <div :class="{ active: activeIndex === 1 }">-->
<!--                          <svg width="96" height="98" viewBox="0 0 96 98" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M49.01 98H45.3613V29.3818C45.3613 13.18 55.9303 0 68.8951 0H95.8951V10.4317C95.8587 30.7028 82.6384 47.1779 66.4019 47.1779C61.3303 47.1779 56.4046 45.5987 52.0627 42.6074L53.8262 38.6291C57.6208 41.256 61.9384 42.6377 66.3167 42.6377C80.6559 42.6377 92.2465 28.167 92.2465 10.3709V4.55531H68.8951C57.9249 4.55531 49.01 15.6855 49.01 29.3818V98Z" fill="black"/>-->
<!--                            <path d="M40.9101 97.9998H37.2614V44.49C37.2614 34.0887 30.4871 25.631 22.156 25.631H4.33843V29.6549C4.33843 43.2601 13.2047 54.3143 24.0898 54.3143C27.4952 54.3143 30.7912 53.2514 33.6979 51.2471L35.4614 55.2254C32.0195 57.6094 28.1033 58.8545 24.1506 58.8545C11.1979 58.8545 0.701937 45.7807 0.677612 29.7005V21.0605H22.1439C32.4817 21.0605 40.8979 31.5681 40.8979 44.4749V97.9998H40.9101Z" fill="black"/>-->
<!--                          </svg>-->
<!--                        </div>-->
<!--                        <input type="radio" class="mt-3" value="Klimat" v-model="universityForm.team_subject_challenge" />-->
<!--                        Klimat-->
<!--                      </label>-->
<!--                      <label @click="activeIndex = 2" class="col text-center box input-control img">-->
<!--                        <div :class="{ active: activeIndex === 2 }">-->
<!--                          <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M49.557 75.0407L69.8683 56.733C73.1258 54.1209 74.9821 50.2944 74.9821 46.2273C74.9821 38.6659 68.551 32.5137 60.6468 32.5137C56.2635 32.5137 52.2037 34.404 49.5091 37.5775C46.8145 34.404 42.7666 32.5137 38.3713 32.5137C30.4671 32.5137 24.036 38.6659 24.036 46.2273C24.036 50.3058 25.9162 54.1438 29.1139 56.6986L49.557 75.0407ZM27.6288 46.2273C27.6288 40.5562 32.4552 35.9507 38.3713 35.9507C42.3953 35.9507 46.048 38.0701 47.9043 41.4957L49.4971 44.4286L51.0899 41.4957C52.9462 38.0701 56.5989 35.9507 60.6228 35.9507C66.551 35.9507 71.3653 40.5677 71.3653 46.2273C71.3653 49.2633 69.9641 52.1389 67.4492 54.1667L49.521 70.3205L31.4971 54.1209C29.042 52.1618 27.6288 49.2862 27.6288 46.2273Z" fill="black"/>-->
<!--                            <path d="M97.8447 47.3846C96.1201 26.8543 80.683 9.94435 59.9285 5.43044C59.5573 2.38298 56.8866 0 53.6052 0C50.0722 0 47.21 2.74959 47.21 6.11784C47.21 9.48609 50.0842 12.2357 53.6052 12.2357C56.1082 12.2357 58.2639 10.838 59.3177 8.8216C78.4674 13.072 92.683 28.6989 94.2639 47.6596C94.8028 54.1211 93.8686 60.4566 91.4974 66.4714L94.8627 67.6858C97.4136 61.1898 98.4315 54.3617 97.8447 47.3846ZM53.6052 8.79869C52.0603 8.79869 50.8028 7.59574 50.8028 6.11784C50.8028 4.63993 52.0603 3.43699 53.6052 3.43699C55.1501 3.43699 56.4076 4.63993 56.4076 6.11784C56.4076 7.59574 55.1501 8.79869 53.6052 8.79869Z" fill="black"/>-->
<!--                            <path d="M86.7784 70.9157C83.2694 70.9157 80.4071 73.6538 80.4071 77.0106C80.4071 78.5344 81.0179 79.9091 81.976 80.9746C74.2514 88.788 63.8682 93.5654 52.6227 94.4247C27.6885 96.3265 5.74843 78.4656 3.74843 54.59C1.88016 32.3641 18.4071 12.0286 41.3652 8.30522L40.7664 4.91406C15.5688 9.00408 -1.88031 30.4738 0.167589 54.865C2.21549 79.3592 23.7125 97.9992 48.97 97.9992C50.2754 97.9992 51.5927 97.9533 52.9221 97.8502C65.2933 96.8993 76.6826 91.5835 85.0658 82.8535C85.6167 83.0024 86.1796 83.1055 86.7784 83.1055C90.2873 83.1055 93.1496 80.3674 93.1496 77.0106C93.1496 73.6424 90.2873 70.9157 86.7784 70.9157ZM86.7784 79.6686C85.2454 79.6686 83.9999 78.4771 83.9999 77.0106C83.9999 75.5442 85.2454 74.3527 86.7784 74.3527C88.3113 74.3527 89.5568 75.5442 89.5568 77.0106C89.5568 78.4771 88.3113 79.6686 86.7784 79.6686Z" fill="black"/>-->
<!--                            <path d="M38.8505 85.8225L39.0421 85.8798C48.4194 88.3315 58.2996 87.2546 66.8745 82.8667C85.2577 73.4379 92.2038 51.4641 82.3475 33.8782C72.4912 16.2808 49.5212 9.63596 31.1379 19.0648C18.3954 25.595 10.6709 38.5983 11.2218 52.3692C9.47326 52.9191 7.96428 54.1564 7.23374 55.9207C5.9523 59.0599 7.56907 62.6229 10.8505 63.8487C14.1319 65.0746 17.8565 63.5279 19.1379 60.3774C20.4194 57.2383 18.8026 53.6752 15.5212 52.4494C15.2816 52.3577 15.0421 52.3234 14.8026 52.2546C14.2996 39.7784 21.2936 28.0009 32.8266 22.0893C49.4613 13.5541 70.2637 19.5689 79.1739 35.4821C88.096 51.3954 81.8086 71.2955 65.1739 79.8193C57.4134 83.7947 48.4673 84.7685 40.0242 82.5574L39.8685 82.5116C31.4493 80.0828 24.4074 74.7096 20.0481 67.4003L16.9343 69.1073C21.2457 76.325 27.9284 81.8356 35.9523 84.8487C36.8984 85.2153 37.8685 85.5361 38.8505 85.8225ZM15.7966 59.1286C15.2337 60.5034 13.605 61.1908 12.1679 60.6523C10.7307 60.1139 10.0122 58.5558 10.5751 57.181C11.1379 55.8062 12.7667 55.1188 14.2038 55.6572C15.6529 56.1957 16.3595 57.7538 15.7966 59.1286Z" fill="black"/>-->
<!--                          </svg>-->
<!--                        </div>-->
<!--                        <input type="radio" class="mt-3" value="Zdrowie" v-model="universityForm.team_subject_challenge" />-->
<!--                        Zdrowie-->
<!--                      </label>-->
<!--                      <label @click="activeIndex = 3" class="col text-center box input-control img">-->
<!--                        <div :class="{ active: activeIndex === 3 }">-->
<!--                          <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M49.9964 67.4961L43.9973 42.3328C47.3808 40.2831 49.5045 36.5936 49.5045 32.5545C49.5045 26.2607 44.4053 21.1484 38.1543 21.1484C31.8913 21.1484 26.8041 26.2727 26.8041 32.5545C26.8041 36.5936 28.9157 40.2952 32.3112 42.3328L26.3121 67.4961H49.9964ZM35.0827 39.7164C32.2272 38.4866 30.3915 35.6773 30.3915 32.5545C30.3915 28.2622 33.8709 24.7656 38.1423 24.7656C42.4136 24.7656 45.893 28.2622 45.893 32.5545C45.893 35.6652 44.0453 38.4866 41.2018 39.7164L39.81 40.3193L45.4251 63.879H30.8594L36.4745 40.3193L35.0827 39.7164Z" fill="black"/>-->
<!--                            <path d="M74.4715 52.3892L64.3931 40.1994L61.6216 42.5144L72.7798 56.0063H76.1513L97.9998 31.7594L95.3363 29.3359L74.5555 52.3892H74.4715Z" fill="black"/>-->
<!--                            <path d="M72.6965 60.8765C72.6965 61.9979 72.6245 63.1192 72.5045 64.1923L72.4085 64.9519C72.1206 66.9051 71.6047 68.7499 70.9208 70.4861C70.7648 70.884 70.5968 71.2698 70.4169 71.6556C70.2729 71.9691 70.1289 72.2705 69.9849 72.572C69.805 72.9337 69.613 73.3075 69.409 73.6571C69.289 73.8741 69.1571 74.0912 69.0251 74.3082C68.7611 74.7423 68.4852 75.1763 68.1972 75.5983C68.1132 75.7189 68.0292 75.8395 67.9453 75.96C67.5973 76.4423 67.2374 76.9246 66.8654 77.4069C66.7694 77.5275 66.6735 77.648 66.5775 77.7686C66.1455 78.2991 65.7016 78.8176 65.2217 79.324C65.2217 79.324 65.2217 79.336 65.2097 79.336C64.7058 79.8786 64.1778 80.3971 63.6139 80.9276C63.5779 80.9638 63.53 80.9999 63.494 81.0481C62.942 81.5666 62.3541 82.073 61.7542 82.5794C61.7182 82.6156 61.6822 82.6397 61.6343 82.6759C60.4104 83.6887 59.0787 84.6532 57.6509 85.5937C57.6029 85.6299 57.5429 85.666 57.4949 85.6902C56.823 86.1242 56.1271 86.5462 55.4192 86.9682C55.2993 87.0406 55.1793 87.1008 55.0713 87.1732C54.3874 87.5711 53.6915 87.9569 52.9716 88.3307C52.8157 88.4151 52.6717 88.4874 52.5157 88.5718C51.8198 88.9335 51.0999 89.2952 50.356 89.6328C50.1881 89.7172 50.0081 89.7896 49.8401 89.874C49.1082 90.2116 48.3643 90.5492 47.5965 90.8747C47.4165 90.9471 47.2365 91.0194 47.0686 91.0918C46.2887 91.4173 45.4968 91.7308 44.6809 92.0443C44.513 92.1046 44.357 92.1648 44.189 92.2251C43.3372 92.5386 42.4613 92.8521 41.5614 93.1535C41.4534 93.1897 41.3335 93.2259 41.2255 93.2741C40.2176 93.6117 39.1978 93.9372 38.154 94.2507C37.674 94.106 37.1941 93.9614 36.7142 93.8046C36.5822 93.7564 36.4382 93.7202 36.3063 93.672C35.9703 93.5635 35.6344 93.455 35.2864 93.3464C35.0705 93.2741 34.8665 93.2018 34.6505 93.1294C34.3866 93.045 34.1226 92.9486 33.8706 92.8642C33.6187 92.7798 33.3667 92.6833 33.1148 92.5868C32.8988 92.5024 32.6708 92.4301 32.4549 92.3457C32.1669 92.2372 31.891 92.1287 31.603 92.0322C31.411 91.9599 31.2311 91.8875 31.0391 91.8152C30.7271 91.6946 30.4152 91.574 30.1032 91.4414C29.9473 91.3811 29.7913 91.3088 29.6353 91.2485C29.2994 91.1159 28.9634 90.9712 28.6275 90.8265C28.4955 90.7783 28.3755 90.718 28.2435 90.6698C27.8836 90.513 27.5236 90.3563 27.1637 90.1995C27.0797 90.1634 26.9957 90.1151 26.8997 90.079C26.5038 89.8981 26.1079 89.7172 25.7239 89.5364C25.6879 89.5243 25.6519 89.5002 25.6159 89.4882C22.9284 88.198 20.3008 86.7391 17.8652 85.0752C17.8292 85.0511 17.8052 85.027 17.7692 85.015C17.4332 84.7859 17.1093 84.5568 16.7853 84.3156C16.6894 84.2433 16.5814 84.171 16.4854 84.0986C16.1974 83.8936 15.9215 83.6766 15.6455 83.4596C15.5015 83.3511 15.3696 83.2425 15.2376 83.134C14.9976 82.9411 14.7457 82.7362 14.5057 82.5432C14.3377 82.4106 14.1818 82.2659 14.0138 82.1333C13.7978 81.9524 13.5939 81.7716 13.3899 81.5787C13.2099 81.4099 13.0179 81.2411 12.838 81.0723C12.658 80.9035 12.478 80.7347 12.2981 80.5659C12.0941 80.3729 11.8901 80.168 11.6981 79.963C11.5542 79.8183 11.3982 79.6616 11.2542 79.5048C11.0263 79.2637 10.8103 79.0225 10.5943 78.7814C10.4863 78.6608 10.3664 78.5282 10.2584 78.3956C10.0064 78.1062 9.76646 77.8168 9.52649 77.5154C9.4545 77.431 9.38252 77.3345 9.31053 77.2501C9.02257 76.8884 8.74662 76.5147 8.48266 76.1409C8.44666 76.1047 8.42267 76.0686 8.39867 76.0444C6.61095 73.5124 5.25517 70.7031 4.4393 67.5924C4.4273 67.5562 4.4273 67.52 4.4153 67.4839C4.29532 67.0257 4.18734 66.5555 4.10335 66.0852C4.07935 65.9767 4.06736 65.8682 4.04336 65.7597C3.75541 64.1923 3.59943 62.5766 3.59943 60.8765V12.1415L38.142 3.7136L72.6845 12.1415V43.5263H76.2839V9.29606L38.142 0L0 9.29606V60.8765C0 62.444 0.107983 63.9873 0.335947 65.4824V65.4944C0.467926 66.3625 0.635899 67.2186 0.839867 68.0626C0.851865 68.1229 0.863863 68.1832 0.88786 68.2435C1.10383 69.0875 1.35579 69.9315 1.63174 70.7513C1.64374 70.7875 1.65574 70.8116 1.66774 70.8478C5.27917 81.1325 14.7577 89.3796 29.6473 95.143C29.7313 95.1791 29.8153 95.2032 29.8993 95.2394C31.0631 95.6855 32.2509 96.1196 33.4747 96.5295C33.5947 96.5657 33.7147 96.6019 33.8347 96.6501C35.0585 97.0601 36.3183 97.4579 37.6141 97.8438C37.626 97.8438 37.638 97.8558 37.65 97.8558L38.154 98.0005L38.6579 97.8558C38.6939 97.8438 38.7299 97.8317 38.7539 97.8196C40.0497 97.4338 41.3095 97.0359 42.5333 96.626C42.7732 96.5416 43.0012 96.4572 43.2292 96.3848C44.309 96.0111 45.3768 95.6252 46.4087 95.2394C46.5166 95.1912 46.6366 95.155 46.7446 95.1068C61.3103 89.464 70.6088 81.5425 74.4122 71.4386L74.3882 71.4266C75.1201 69.4974 75.66 67.52 75.972 65.4462L76.08 64.6384C76.2239 63.4085 76.3079 62.1425 76.3079 60.8765V60.2134H72.7085V60.8765H72.6965Z" fill="black"/>-->
<!--                          </svg>-->
<!--                        </div>-->
<!--                        <input type="radio" class="mt-3" value="Bezpieczeństwo" v-model="universityForm.team_subject_challenge" />-->
<!--                        Bezpieczeństwo-->
<!--                      </label>-->
<!--                      <label @click="activeIndex = 4" class="col text-center box input-control img">-->
<!--                        <div :class="{ active: activeIndex === 4 }">-->
<!--                          <svg width="94" height="98" viewBox="0 0 94 98" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M8.72681 62.2404C8.72681 71.5457 12.3081 80.3602 18.8016 87.0643C25.2262 93.6998 33.8154 97.5573 42.9948 97.9598V97.999H45.8972L46.1432 97.9696C55.3325 97.5573 63.9216 93.6998 70.3364 87.0643C76.8299 80.3602 80.4112 71.5457 80.4112 62.2404V60.6699H8.72681V62.2404V62.2404ZM11.9145 63.8109H43.0047V94.8286C26.2986 94.0335 12.7115 80.478 11.9145 63.8109ZM46.153 94.8286V63.8109H77.2431C76.4462 80.478 62.859 94.0335 46.153 94.8286V94.8286Z" fill="black"/>-->
<!--                            <path d="M37.4164 17.0996H35.8422C16.0763 17.0996 0 33.1385 0 52.8582V54.4287H37.4164V17.0996ZM34.268 20.2799V51.2975H3.18772C3.98465 34.6305 17.5718 21.075 34.2778 20.2799H34.268Z" fill="black"/>-->
<!--                            <path d="M57.6447 0H56.0706V37.3291H93.4869V35.7586C93.4869 16.0389 77.4106 0 57.6447 0ZM59.2189 34.1881V3.18029C75.9249 3.97536 89.5121 17.5308 90.309 34.1979H59.2189V34.1881Z" fill="black"/>-->
<!--                          </svg>-->
<!--                        </div>-->
<!--                        <input type="radio" class="mt-3" value="Integracja" v-model="universityForm.team_subject_challenge" />-->
<!--                        Integracja-->
<!--                      </label>-->
<!--                    </b-row>-->
<!--                    <h5 class="mt-5 mb-4">Jakie wyzwania zidentyfikowaliście i dlaczego jest ono dla Was ważne?</h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea required placeholder="Opisz Wasze wyzwania" rows="6" v-model="universityForm.team_challenges"></b-textarea>-->
<!--                        <p>Opisz Wasze wyzwania</p>-->
<!--                      </div>-->
<!--                      <small class="maxlength-label">{{getWordsLeft(universityForm.team_challenges, 300)}}</small>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">Przykuj naszą uwagę. W atrakcyjny i krótki sposób przedstaw swoje wyzwanie.</h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea required placeholder="Przedstaw swoje wyzwanie" rows="3" v-model="universityForm.team_idea_short_description"></b-textarea>-->
<!--                        <p>Przedstaw swoje wyzwanie</p>-->
<!--                        <small class="maxlength-label">{{getWordsLeft(universityForm.team_idea_short_description, 30)}}</small>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Opowiedz nam więcej o Waszym wyzwaniu (lub pomyśle). Co się stanie, jeśli nic się nie zmieni?-->
<!--                      Jaki byłby pozytywny wpływ rozwiązania, które proponujecie w perspektywie krótko- i długoterminowej?-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea required placeholder="Opisz Wasze wyzwanie/pomysł" rows="6" v-model="universityForm.team_idea_description"></b-textarea>-->
<!--                        <p>Opisz Wasze wyzwanie/pomysł</p>-->
<!--                        <small class="maxlength-label">{{getWordsLeft(universityForm.team_idea_description, 300)}}</small>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Kogo dotyczy proponowane przez Wasz zespół rozwiązanie? Opisz grupę docelową.-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea required placeholder="Opisz grupę docelową" rows="4" v-model="universityForm.team_target"></b-textarea>-->
<!--                        <p>Opisz grupę docelową</p>-->
<!--                        <small class="maxlength-label">{{getWordsLeft(universityForm.team_target, 100)}}</small>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Sojusznicy. Z kim możesz współpracować, kogo poprosić o radę, pomoc, wsparcie, aby zrealizować swój pomysł, odpowiedzieć na postawione wyzwanie i wprowadzić zmiany?-->
<!--                    </h5>-->
<!--                    <label class="w-100">-->
<!--                      <div class="input-box">-->
<!--                        <b-textarea required placeholder="Opisz sojusznika" rows="4" v-model="universityForm.team_ally"></b-textarea>-->
<!--                        <p>Opisz sojusznika</p>-->
<!--                        <small class="maxlength-label">{{getWordsLeft(universityForm.team_ally, 100)}}</small>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                    <h5 class="mt-5 mb-4">-->
<!--                      Jakie są 3 najważniejsze rzeczy, których Twój zespół chciałby się nauczyć, aby zrealizować postawione wyzwanie i odpowiedzieć-->
<!--                      na zidentyfikowane potrzeby w swojej społeczności lokalnej?-->
<!--                    </h5>-->
<!--                    <div class="input-box">-->
<!--                      <b-textarea required placeholder="Wypisz 3 rzeczy" rows="3" v-model="universityForm.team_goal"></b-textarea>-->
<!--                      <p>Wypisz 3 rzeczy</p>-->
<!--                    </div>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--              <b-col cols="12">-->
<!--                <h4 class="form-section-title">I ostatnie pytanie...</h4>-->
<!--                <b-row>-->
<!--                  <b-col cols="12">-->
<!--                    <h5 class="mt-5 mb-4">Skąd dowiedziałeś/dowiedziałaś się o Solve for Tomorrow?</h5>-->
<!--                    <b-form-radio-group>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Strona Samsung" value="Strona Samsung" v-model="universityForm.sft_find_out" />-->
<!--                        Strona Samsung-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input id="Media-media" type="radio" name="Media-media" value="Media" v-model="universityForm.sft_find_out" />-->
<!--                        Media-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="E-mail do szkoły" value="E-mail do szkoły" v-model="universityForm.sft_find_out" />-->
<!--                        E-mail do szkoły-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Facebook" value="Facebook" v-model="universityForm.sft_find_out" />-->
<!--                        Facebook-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Kuratorium Oświaty" value="Kuratorium Oświaty" v-model="universityForm.sft_find_out" />-->
<!--                        Kuratorium Oświaty-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Grupy nauczycielskie na Facebooku" value="Grupy nauczycielskie na Facebooku" v-model="universityForm.sft_find_out" />-->
<!--                        Grupy nauczycielskie na Facebooku-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Przez szkołę" value="Przez szkołę" v-model="universityForm.sft_find_out" />-->
<!--                        Przez szkołę-->
<!--                      </label>-->
<!--                      <label class="input-control">-->
<!--                        <input type="radio" name="Inne" value="Inne" v-model="universityForm.sft_find_out" />-->
<!--                        Inne-->
<!--                      </label>-->
<!--                    </b-form-radio-group>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-else-if="currentStep === 1">-->
<!--              <b-col class="mt-5">-->
<!--                <p class="text-center">-->
<!--                  Aplikacja wypełniona!<br>-->
<!--                  Teraz chcemy się tylko upewnić, że przeczytałeś/przeczytałaś regulamin.-->
<!--                  <br>-->
<!--                  Poprosimy Cię także o zaznaczenie zgód.-->
<!--                </p>-->
<!--                <p class="text-center mt-4">-->
<!--                  Pozostał Ci już tylko ostatni krok, jakim jest wysłanie zgłoszenia.<br>-->
<!--                </p>-->
<!--                <h4 class="mt-5 mb-4 text-center">Regulamin</h4>-->
<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="universityForm.regulation_consent" />-->
<!--                  <p class="mb-0">Oświadczam, że zapoznałem/zapoznałam się z <a href="https://solvefortomorrow.pl/wp-content/uploads/2022/09/regulamin_Solve_for_Tomorrow_PL_20_09_2022_mini.pdf" target="_blank">regulaminem</a> programu. <span class="color-span">*</span></p>-->
<!--                </label>-->
                <!--                <b-checkbox class="mb-3" required v-model="schoolForm.regulation_consent">Oświadczam, że zapoznałem/zapoznałam się z regulaminem programu i akceptuję jego postanowienia.</b-checkbox>-->
                <!--                <label class="input-control mb-3">-->
                <!--                  <input type="checkbox" required v-model="schoolForm.team_regulation_consent" />-->
                <!--                  Oświadczam, że zapoznałem/zapoznałam z regulaminem programu wszystkich członków i członkinie mojego zespołu. Wszyscy zaakceptowali jego postanowienia.-->
                <!--                </label>-->
                <!--                <b-checkbox required v-model="schoolForm.team_regulation_consent">Oświadczam, że zapoznałem/zapoznałam z regulaminem programu wszystkich członków i członkinie mojego zespołu. Wszyscy zaakceptowali jego postanowienia.</b-checkbox>-->
<!--                <h4 class="mt-5 mb-4 text-center">Zgody</h4>-->
<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="universityForm.personal_data_consent" />-->
<!--                  <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow.<span class="color-span">*</span></p>-->
<!--                  &lt;!&ndash;                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">(do pobrania TUTAJ)</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.&ndash;&gt;-->
<!--                </label>-->
                <!--                <b-checkbox class="mb-3" required v-model="schoolForm.personal_data_consent">-->
                <!--                  Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. Posiadam wypełnione i podpisane oświadczenie-->
                <!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">(do pobrania TUTAJ)</a>-->
                <!--                  i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
                <!--                </b-checkbox>-->
<!--                <label class="input-control mb-3">-->
<!--                  <input type="checkbox" required v-model="universityForm.personal_image_consent" />-->
<!--                  <div>-->
<!--                    <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych oraz wizerunku w celach związanych z udziałem w programie Solve for Tomorrow. Posiadam wypełnione i podpisane oświadczenie-->
<!--                      <a href="https://solvefortomorrow.pl/wp-content/uploads/2022/09/SFT_RODO_uczestnik_niepelnoletni_oraz_pelnoletni_2_edycja.pdf" target="_blank">(do pobrania TUTAJ)</a>-->
<!--                      i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.</p>-->
<!--                  </div>-->
<!--                </label>-->
                <!--                <label class="input-control mb-3">-->
                <!--                  <input type="checkbox" required v-model="schoolForm.personal_image_consent" />-->
                <!--                  Posiadam wypełnione i podpisane zgody na przetwarzanie danych osobowych i wizerunku (-->
                <!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">do pobrania TUTAJ zgoda dla osoby pełnoletniej</a> i <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_dziecko.pdf" target="_blank">dla osoby niepełnoletniej)</a> od wszystkich członków i członkiń mojego zespołu (w przypadku osób niepełnoletnich podpisane przez rodziców/opiekunów prawnych) i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
                <!--                </label>-->
                <!--                <b-checkbox required v-model="schoolForm.personal_image_consent">Posiadam wypełnione i podpisane zgody na przetwarzanie danych osobowych i wizerunku (-->
                <!--                  <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_uczestnik_pelnoletni.pdf" target="_blank">do pobrania TUTAJ zgoda dla osoby pełnoletniej</a> i <a href="http://solvefortomorrow.pl/wp-content/uploads/2021/09/SFT_RODO_dziecko.pdf" target="_blank">dla osoby niepełnoletniej)</a> od wszystkich członków i członkiń mojego zespołu (w przypadku osób niepełnoletnich podpisane przez rodziców/opiekunów prawnych) i w każdej chwili jestem gotowa/gotowy przekazać je Organizatorowi Solve for Tomorrow.-->
                <!--                </b-checkbox>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-else-if="currentStep === 2">-->
<!--              <b-col class="text-center my-5">-->
<!--                <h3 v-if="!errorAlert">Dziękujemy za wypełnienie formularza!<br>-->
<!--                  Twoje zgłoszenie już do nas trafiło.-->
<!--                  Teraz potrzebujemy trochę czasu na jego analizę.<br>-->
<!--                  Do usłyszenia!-->
<!--                </h3>-->
<!--                <h3 v-else>-->
<!--                  Ups... Coś poszło nie tak!<br />-->
<!--                  Spróbuj ponownie później!-->
<!--                </h3>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row>-->
<!--              <b-col v-if="currentStep < 2" class="mt-5 mb-3 d-inline-flex justify-content-end">-->
<!--                <b-button v-if="currentStep > 0" @click="currentStep&#45;&#45;" variant="info">Wróć</b-button>-->
<!--                <b-button class="ml-4" type="submit" variant="primary">Dalej</b-button>-->
<!--              </b-col>-->
<!--              <b-col v-else class="mt-5 mb-3 text-center">-->
<!--                <router-link to="/"><b-button variant="primary">Wróć na stronę główną</b-button></router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </b-container>-->
    </form>
  </section>
  </div>
</template>

<script>
import mainImage from '../../assets/media/images/register-samsung.jpg'
import wp_api_client from "@/store/wp_api_client";

const api = new wp_api_client(process.env.VUE_APP_API_URL)

const regexMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const voivodeships = [
      'dolnośląskie',
      'kujawsko-pomorskie',
      'lubelskie',
      'lubuskie',
      'łódzkie',
      'małopolskie',
      'mazowieckie',
      'opolskie',
      'podkarpackie',
      'podlaskie',
      'pomorskie',
      'śląskie',
      'świętokrzyskie',
      'warmińsko-mazurskie',
      'wielkopolskie',
      'zachodniopomorskie',
    ];
const teacherRoles = [
  'Dyrektor/ka',
  'Wicedyrektor/ka',
  'Nauczyciel/ka',
  'Bibliotekarz/rka',
  'Opiekun/ka świetlicy',
  'Inne'
];
const editions = [
  'Do 1 edycji',
  'Do 2 edycji',
  'Nie',
];
const schoolForm = {
  type_of_school: "Ponadpodstawowa",
  first_name: null,
  // last_name: null,
  email: null,
  phone: null,
  first_name_leader: null,
  email_leader: null,
  phone_leader: null,
  subjects: null,
  role: null,
  custom_role: null,
  editions: [],
  school_name:null,
  school_voivodeship:null,
  school_street:null,
  school_zip:null,
  school_city:null,
  team_members: [
    {
      firstname: '',
      // lastname: '',
      age: ''
    },
    {
      firstname: '',
      // lastname: '',
      age: ''
    },
    {
      firstname: '',
      // lastname: '',
      age: ''
    },
    {
      firstname: '',
      // lastname: '',
      age: ''
    },
  ],
  // about_team: null,
  director_consent:false,
  parental_consent:false,
  team_subject_challenge:null,
  team_challenges:null,
  team_idea_short_description: null,
  // team_idea_description: null,
  team_target: null,
  team_ally: null,
  // team_goal: null,
  sft_find_out: null,
  sft_find_out_diffrent: null,
  regulation_consent: false,
  team_regulation_consent: false,
  personal_data_consent: false,
  personal_image_consent: false,
};
const universityForm = {
  type_of_school: null,
  first_name: null,
  // last_name: null,
  email: null,
  phone: null,
  subjects: null,
  role: null,
  school_name:null,
  school_voivodeship:null,
  school_street:null,
  school_zip:null,
  school_city:null,
  team_members: [
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
  ],
  about_team: null,
  director_consent:null,
  parental_consent:null,
  team_subject_challenge:null,
  team_challenges:null,
  team_idea_short_description: null,
  team_idea_description: null,
  team_target: null,
  team_ally: null,
  team_goal: null,
  sft_find_out: null,
  regulation_consent: null,
  // team_regulation_consent: null,
  personal_data_consent: null,
  personal_image_consent: null,
};

export default {
  name: "RegisterForm",
  data(){
    return {
      showModal: false,
      isSelectFocused: false,
      currentStep: 0,
      teamSize: 1,
      formSelected: 'school',
      voivodeships: voivodeships,
      teacherRoles: teacherRoles,
      editions: editions,
      schoolForm: JSON.parse(JSON.stringify(schoolForm)),
      universityForm: universityForm,
      mainImage: mainImage,
      activeIndex: 0,
      errorAlert: false,
      wordsLimitIdea:  false,
      wordsTeamChallenge: false,
      wordsTeamTarget: false,
      wordsTeamAlly: false,
      emptyFields: false,
      formSend: false,
      formTimeout: null,
      validEmail: false,
      emailValidTimeout: null,
    }
  },
  methods: {
    getWordsLeft(str, limit, el) {
      if(str) {
       const maxLengthSigns = 3000
       let wordsLeft = limit - str.split(' ').length
       let signs = str.length
       let signsLeft = maxLengthSigns > signs
       if(wordsLeft >= 0 && signsLeft) {
         switch (el) {
           case 'team_idea_short_description':
             this.wordsLimitIdea = false;
             break;
           case 'team_challenges':
             this.wordsTeamChallenge = false;
             break;
           case 'team_target':
             this.wordsTeamTarget = false;
             break;
           case 'team_ally':
             this.wordsTeamAlly = false;
             break;
         }
         return 'Pozostało ' + wordsLeft + ' słów';
       }
       else {
         switch (el) {
           case 'team_idea_short_description':
             this.wordsLimitIdea = true;
             break;
           case 'team_challenges':
             this.wordsTeamChallenge = true;
             break;
           case 'team_target':
             this.wordsTeamTarget = true;
             break;
           case 'team_ally':
             this.wordsTeamAlly = true;
             break;
         }
         return signsLeft ? 'Przekroczono limit słów o ' + wordsLeft*(-1)  : 'Przekroczono limit znaków';
       }
      }
      else {
        switch (el) {
          case 'team_idea_short_description':
            this.wordsLimitIdea = false;
            break;
          case 'team_challenges':
            this.wordsTeamChallenge = false;
            break;
          case 'team_target':
            this.wordsTeamTarget = false;
            break;
          case 'team_ally':
            this.wordsTeamAlly = false;
            break;
        }
        return 'Pozostało ' + limit + ' słów';
      }
    },
    nextStep(e) {
      e.preventDefault()
      if(this.currentStep === 1) this.handleFormSubmit()
      else  {
        if(this.checkEmail()) {
          this.validEmail = true;

          if (this.emailValidTimeout !== null) {
            clearTimeout(this.emailValidTimeout);
          }

          this.emailValidTimeout = setTimeout(() => {
            this.validEmail = false;
          }, 4000);
        } else if(this.schoolForm.editions.length === 0 || (!this.schoolForm.sft_find_out && !this.schoolForm.sft_find_out_diffrent)
            || !this.schoolForm.team_subject_challenge || this.validateFormValues(
                [
                    'custom_role',
                    'role',
                    'editions',
                    'personal_data_consent',
                    'personal_image_consent',
                    'regulation_consent',
                    'sft_find_out',
                    'sft_find_out_diffrent',
                    'subjects',
                    'team_members',
                ]
            )) {
          this.validEmail = false;
          this.emptyFields = true;
          if (this.formTimeout !== null) {
            clearTimeout(this.formTimeout);
          }

          this.formTimeout = setTimeout(() => {
            this.emptyFields = false;
          }, 4000);

        }
        else if (!this.wordsLimitIdea && !this.wordsTeamChallenge && !this.team_target && !this.wordsTeamAlly && this.validatePhoneFormat(this.schoolForm.phone)
          && this.validatePhoneFormat(this.schoolForm.phone_leader)) {
          this.validEmail = false;
          this.emptyFields = false;
          this.currentStep++
        }
      }
    },
    handleFormSubmit() {
      this.currentStep++
      api.sendApplicationForm(this.formSelected === 'school' ? this.schoolForm : this.universityForm)
        .then((res) => {
          if(res.status !== 200) {
            this.errorAlert = true
          }
          this.formSend = true
        })
        .catch(e => {
          this.errorAlert = true
          console.log(e.response.data)
        })
    },
    validateFormValues(excludeFields) {
      for (const key in this.schoolForm) {
        if (!excludeFields.includes(key)) {
          const value = this.schoolForm[key];
          if (value === null || value === undefined || value === false || value === "") {
            return true;
          }
        }
      }
      return false;
    },
    validatePhoneFormat(phone) {
      const regex = /^\d{3} \d{3} \d{3}$/;

      return regex.test(phone);
    },
    checkEmail() {
      return !!(this.schoolForm.email_leader && !regexMail.test(this.schoolForm.email_leader)
          || this.schoolForm.email && !regexMail.test(this.schoolForm.email));
    },
    onFocus() {
      this.isSelectFocused = true;
    },
    onBlur() {
      this.isSelectFocused = false;
    },
    onSelectChange() {
      this.isSelectFocused = false;
      this.isSelectFocused = !this.isSelectFocused;
    },
    toggleDropdown() {
      this.isSelectFocused = !this.isSelectFocused;
    },
    formatZipCode(event) {
      let value = event.replace(/\D/g, '');
      if (value.length > 5) {
        return
      }
      if (value.length > 2) {
        value = value.slice(0, 2) + '-' + value.slice(2);
      }
      this.schoolForm.school_zip = value;
    },
    checkIfFormFilled() {
      if (this.isFormFilled()) {
        this.showModal = true
      } else {
        this.goBack();
      }
    },
    isFormFilled() {
      for (let key in this.schoolForm) {
        if (key !== 'type_of_school') {
          const value = this.schoolForm[key];

          if (typeof value === 'string' && value.trim() !== '') {
            return true;
          }

          if (Array.isArray(value) && value.length > 0 && key !== 'team_members') {
            return true;
          }

          if (typeof value === 'boolean' && value === true) {
            return true;
          }
        }
      }

      return this.schoolForm.team_members.some(member =>
        member.firstname.trim() !== '' || member.age.trim() !== ''
      );
    },
    goBack() {
      this.$router.push('/');
    },
    cancel() {
      this.showModal = false;
    },
    formatPhone(event) {
      let value = event.replace(/\D/g, "");

      value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

      if (value.length > 11) {
        return
      }

      this.schoolForm.phone = value;
    },
    formatPhoneLeader(event) {
      let value = event.replace(/\D/g, "");

      value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

      if (value.length > 11) {
        return
      }

      this.schoolForm.phone_leader = value;
    },
  },
  beforeDestroy() {
    this.schoolForm = JSON.parse(JSON.stringify(schoolForm));
  },
}
</script>

<style scoped lang="scss">
.form {
  position: relative;
  background-color: $main-bg;
  padding-top: 80px;
  padding-bottom: 80px;
  color: $main-color;
  overflow: hidden;
  min-height: 100vh;

  & label {
    margin-bottom: unset;
  }

  & .shape-1 {
    position: absolute;
    top: 0;
    left: 0;
    opacity: .2;
  }

  & .shape-2 {
    position: absolute;
    top: 130px;
    right: 0;

    &.step1 {
      top: 380px;
    }

    &.step2 {
      top: unset;
      bottom: 120px;
    }
  }

  & .shape-3 {
    position: absolute;
    top: 350px;
    right: 15%;
    opacity: .2;

    @include media-breakpoint-down(lg){
      display: none;
    }

    &.step1 {
      top: 490px;
    }

    &.step2 {
      top: unset;
      bottom: -10%;
    }
  }

  & h5 {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
    margin-top: 32px;
  }

  .box-return {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-left: -12px;
    margin-bottom: 40px;

    &--point {
      cursor: pointer;
    }

    & p {
      margin-bottom: 0;
      font-size: 1.125em;
      font-style: normal;
      font-weight: 500;
      line-height: 25px;
    }

    & img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }

  & .regular-text {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .regular-big-text {
    font-family: "Samsung Sharp Sans";
    font-size: 1em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .regular-consent {
    font-family: "Samsung Sharp Sans";
    font-size: .78em;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .margin-16 {
    margin-top: 16px;

    & p {
      margin-bottom: 0;
    }
  }

  &-title {
    font-size: 1.75em;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }

  &-head {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__link {
      text-align: center;
      font-size: 1.25em;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      text-decoration-line: underline;
      color: $main-color;
    }

    &__box {

      & p {
        text-align: center;
        font-family: "Samsung Sharp Sans";
        font-size: 1.25em;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 32px;
        margin-bottom: 0;
      }
    }
  }

  &-content {
    position: relative;
    padding: 48px 0 64px 0;
    margin-top: 62px;
    background-color: $white;
    border-radius: 20px;
  }
}

.main-image {
  height: 500px;
  width: 100%;
  object-fit: cover;
}
.main-header {
  font-weight: 700;
  color: white;
  font-size: 48px;
  @include media-breakpoint-down(sm) {
    left: 2%;
    font-size: 32px;
  }
}
.link-statute {
  color: black;
  text-decoration: underline;
}
.team-size-btn {
  width: 120px;
  text-align: center;
  cursor: pointer;
  border: 2px solid black;
  border-radius: 20px;
  padding: 16px;
  &.active {
    border-color: #A18037;
  }
}
label{
  position: relative;

  textarea:focus + .maxlength-label {
    color: #C50000;
  }

  .maxlength-label{
    position: absolute;
    left: 0;
    bottom: -20px;
    //color: #C50000;
  }
}
.form-type-buttons {
  margin-top: 6rem;
  margin-bottom: 6rem;
  button {
    max-width: 100%;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: lighter;
  }
}
.form-section-title {
  text-align: center;
  position: relative;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 96px;

  &--small-margin {
    margin-bottom: 40px;
  }

  &:after {
    content: "";
    position: absolute;
    top: calc(100% + 16px);
    left: 0;
    width: 100%;
    height: 3px;
  }
    &.yellow {
      &:after {
        background-color: #FCC157;
      }
    }
    &.blue {
      &:after {
        background-color: #007CC2;
      }
    }
    &.red {
      &:after {
        background-color: #FF4337;
      }
    }
}
.hr_container {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
}
.number {
  background: $main-bg;
  position: relative;
  z-index: 1;
  width: 94px;
  height: 38px;
  font-size: 1.25em;
  font-style: normal;
  line-height: 36px;
  font-weight: 500;
  color: $main-gray;
  border: 2px solid $main-gray;
  border-radius: 100%;
  font-family: Samsung Sharp Sans;
  text-align: center;
  margin: 0 auto;
  &-line {
    width: 100%;
    height: 1px;
    background: $main-gray;
  }
  &-text {
    font-size: .9415em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: $main-gray;

    &.finished {
      color: $main-color;
    }

    &.active {
      color: $main-color;
    }

    &:first-child {
      margin-left: 0;
    }

    &:nth-child(2) {
      margin-left: 30px;
    }

    &:last-child {
      margin-left: 30px;
    }
  }
  &.active{
    font-weight: 700;
    color: $second-blue;
    border-color: $second-blue;
  }
  &.finished{
    color: #878424;
    border-color: #878424;
  }
}
.form-control, .custom-select {
  padding: 8px 0;
  border: none;
  height: calc(1.5em + 1rem);
  border-bottom: 1px solid $second-gray;
  box-shadow: none;
  border-radius: 0!important;
  color: $third-gray!important;
  margin-top: 12px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: $white!important;

  &::-ms-expand {
    display: none;
  }

  & option {
    color: $main-color!important;
  }
  &::placeholder{
    color: #979797;
  }
}
.input {
  border-radius: 10px;

  &.input-number-star {
    padding-left: 12px;
  }
}

.label {
  font-size: 16px;
  font-weight: 500;
  font-family: "Samsung Sharp Sans";
}

.select {
  font-weight: 500;
  font-family: "Samsung Sharp Sans";
}

.box {

  .active {
    svg path {
      fill: #A18037
    }
  }
}

.input-control {
  display: flex;
  align-items: center;
  margin-top: 32px;
  gap: 6px;
  font-size: 18px;
  font-family: "Samsung Sharp Sans";
  padding-left: 0;
  padding-right: 0;

  &--small-margin {
    margin-top: 24px;
  }

  & div {
    display: flex;
  }

  & a {
    color: $main-color;
    text-decoration: underline;
  }
  & p {
    font-size: .78em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &.img {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #000;
    width: 25px;
    height: 25px;
    border: 1px solid #007CC2;
    border-radius: 0.15em;
    display: grid;
    place-content: center;

    &::before {
      content: "";
      width: 25px;
      height: 25px;
    }

    &:checked::before {
      border: none;
      border-radius: 0.15em;
      background: #007CC2 no-repeat center url("../../assets/media/images/mark-blue.svg");
    }
  }
}

.star-box {
  position: relative;
}

.star {
  position: absolute;
  top: 40%;
  left: 6%;
  font-weight: 700;
  font-size: 17px;
  font-family: "Samsung Sharp Sans";
  color: #FF4337;

  &-red {
    color: #FF4337;
  }
}

.input-box {
  position: relative;
  margin-top: 32px;

  & p {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;

    & .color {
      color: #C50076;
    }
  }

  &-instruction {
    display: block;
    font-family: "Samsung Sharp Sans";
    color: $main-color;
    font-size: .8em;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    margin-top: 8px;
  }

  & input:focus + p, & input:not(:placeholder-shown) + p  {
    display: block;
    top: -22%;
  }

  & textarea:focus + p, & textarea:not(:placeholder-shown) + p {
    display: block;
    top: -18%;
  }

  & input:focus::placeholder, & textarea:focus::placeholder {
    opacity: 0;
  }

  & input {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $second-gray;
    box-shadow: none;
    padding: 8px 0;
    height: calc(1.5em + 1rem);
    margin-top: 12px;
    color: $main-color!important;

    &::placeholder {
      font-size: .95em;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      color: $third-gray;
    }
  }

  &.select-box {
    & .select-icon {

      &::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5889 13.0892C10.2635 13.4146 9.73586 13.4146 9.41042 13.0892L4.41042 8.08917C4.08498 7.76374 4.08498 7.2361 4.41042 6.91066C4.73586 6.58523 5.26349 6.58523 5.58893 6.91066L9.99967 11.3214L14.4104 6.91066C14.7359 6.58523 15.2635 6.58523 15.5889 6.91066C15.9144 7.2361 15.9144 7.76374 15.5889 8.08917L10.5889 13.0892Z' fill='%23393947'/%3E%3C/svg%3E%0A");
        position: absolute;
        right: 0;
        top: 73%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
      }

      &.rotate::after {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  & .radio-box {
    gap: 32px;
    & label {
      margin-bottom: 0;
    }

    & input[type="radio"] {
      height: auto;
      margin: 0;
      padding: 0;
      border-bottom: none;
      background: none;
      cursor: pointer;

      &::before {
        width: 28px;
        height: 28px;
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-blue.svg");
      }

      &:checked::before {
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-mark-blue.svg");
      }
    }
  }
}

.radio-box-2 {
  margin-top: 16px;
  align-items: center;
  gap: 6px;

  & input[type="radio"] {
    height: auto;
    margin: 0;
    padding: 0;
    border-bottom: none;
    background: none;
    cursor: pointer;
    border: none;

    &::before {
      width: 28px;
      height: 28px;
      border-radius: 0;
      background: no-repeat center url("../../assets/media/images/radio-blue.svg");
    }

    &:checked::before {
      border-radius: 0;
      background: no-repeat center url("../../assets/media/images/radio-mark-blue.svg");
    }
  }
}

.color-span {
  color: #FF4337;
}

.link {
  font-family: "Samsung Sharp Sans";
  font-size: .875em;
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  color: $main-color;
  padding-top: 0;
  margin-bottom: 0;
  text-decoration: underline;
  margin-left: 32px;

  &:visited, &:hover {
    color: $main-color;
  }
}

.button-new-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px 9px 24px;
  background-color: $secondary;
  border: none;
  margin-right: -12px;
  line-height: normal;
  color: $white;
  transition: all .4s ease;

  &--big {
    line-height: 32px;
    padding: 9px 32px;
    margin-right: 0;
  }

  &--left {
    padding: 9px 24px 9px 16px;
  }

  &:hover {
    background-color: #13588A;
  }
}

.error {
  color: #df2019;
}

::v-deep .modal-dialog {
  max-width: 736px;

  .modal-content {
    padding: 48px 40px;
    border-radius: 8px;
    max-width: 736px;
    width: 100%;
    font-size: 1.065em;
    font-style: normal;
    font-weight: 700;
    color: $main-color;

    & .close {
      display: none;
    }

    & p {
      font-size: 1.06em;
      font-style: normal;
      font-weight: 400;
      margin-bottom: 0;
    }

    & .btn-modal {
      padding: 8px 24px;
      background-color: $secondary;
      color: $white;
      font-size: .95em;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      border: none;

      &.red {
        background-color: #DC0000;
      }
    }

    & .modal-header {
      border: none;
      padding: 0;
      margin-bottom: 16px;
    }

    & .modal-body {
      padding: 0;
      margin-bottom: 32px;
    }

    & .modal-footer {
      border: none;
      padding: 0;
    }
  }
}

.text-18 {
  font-family: "Samsung Sharp Sans";
  font-size: 1.125em;
  font-style: normal;
  font-weight: 500;
  color: $main-color;
}

.consent-box {
  padding: 48px 48px 64px 48px;
  background-color: $white;
  border-radius: 20px;
}

.final-text {
  font-family: "Samsung Sharp Sans";
  font-size: 1.25em;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: $main-color;
}
</style>
